{
  "COMMON": {
    "CATEGORIES": "Kategorier"
  },
  "MODAL": {
    "CLOSE": "Luk"
  },
  "INCIDENT_NOTICE": {
    "TITLE": "Vi beder aldrig om din adgangskode eller kortoplysninger.",
    "BODY": "Den 1. november modtog nogle brugere en falsk notifikation. Har du delt dine oplysninger, så skift din adgangskode og læs vores vejledning.",
    "READ_MORE": "Læs mere",
    "CLOSE": "Luk"
  },
  "COMPONENTS": {
    "VERTICAL_LINK_BOX": {
      "HEADER_TITLE": "Hvad søger du hjælp til?",
      "HEADER_SUBTITLE": "Vælg en type opgave"
    },
    "ACTIVITY": {
      "HEADER": "Det sker på Handyhand lige nu",
      "CLOSE": "Luk vindue",
      "NEW_USER": "$$fullname$$ sluttede sig til Handyhand",
      "NEW_HH": "$$fullname$$ oprettede en profil",
      "NEW_TASK": "Ny opgave: \"$$taskname$$\"",
      "NEW_BID": "$$fullname$$ gav et tilbud på \"$$taskname$$\"",
      "TASK_COMPLETED": "Opgaven  \"$$taskname$$\" er lige blevet afsluttet",
      "TASK_ACCEPTED": "Et tilbud på \"$$taskname$$\" blev accepteret",
      "HH_UPDATED": "$$fullname$$ har opdateret sin profil!",
      "NEW_REVIEW": "$$fullname$$ modtog en 5-stjernet anmeldelse",
      "HH_VISITED": "$$fullname$$ tjekkede opgaven \"$$taskname$$\"",
      "OFFER_COMMENT": "$$fullname$$ kommenterede på \"$$taskname$$\"",
      "TASK_COMMENT": "$$fullname$$ kommenterede på \"$$taskname$$\"",
      "NEW_PAYMENT": "Et bud blev accepteret",
      "VIEW_PROFILE": "Se profil",
      "VIEW_TASK": "Se opgave"
    },
    "CHANGELOG": {
      "TITLE": "Opdateringer på HandyHand platformen",
      "SUBTITLE": "Hold dig opdateret på de seneste forbedringer, vigtig information, samt nye funktioner til HandyHand platformen",
      "USER_SEGMENTS": "Brugertyper",
      "CATEGORIES": "Kategorier",
      "IMPORTANT": "Vigtigt",
      "DANISH": "Dansk",
      "ENGLISH": "Engelsk",
      "SEARCH_PLACEHOLDER": "Søg i changelog...",
      "CLEAR_FILTERS": "Ryd alle filtre",
      "NO_RESULTS": "Ingen resultater fundet",
      "CHANGE_FILTERS": "Prøv at ændre dine filter indstillinger for at se flere resultater."
    },
    "CHATBOT": {
      "WELCOME_TOOLTIP": "Hej! Jeg kan hjælpe med opgaver, spørgsmål og prisoverslag. Spørg løs!",
      "HEADER_TITLE": "Handyhand Assistent",
      "INPUT_PLACEHOLDER": "Skriv din besked her...",
      "CREATE_TASK_BUTTON": "Opret opgave",
      "BACK_TO_CHAT": "Tilbage til chat",
      "PRE_STEP_INTRO": "Jeg kan hjælpe dig med at:",
      "BACK_BUTTON": "Tilbage",
      "BOT_NAME": "Handyhand Bot",
      "CREATE_TASK_NOW": "Opret opgaven",
      "GET_PRICE_ESTIMATE": "Få et prisoverslag",
      "IS_THIS_CORRECT": "Er dette korrekt?",
      "CONFIRM_YES": "Ja",
      "CONFIRM_NO": "Nej",
      "CHECKING_FAQ": "Tjekker ofte stillede spørgsmål...",
      "ERROR_START": "Beklager, jeg kunne ikke starte chatten. Prøv venligst igen senere.",
      "ERROR_SEND": "<p class=\"error-message\">Beklager, der opstod en fejl. Prøv venligst igen.</p>",
      "MESSAGE_MARKERS": {
        "TASK_TITLE_COLON": "Opgavens titel:",
        "TASK_DESCRIPTION_COLON": "Opgavens beskrivelse:",
        "CONFIRM_TOKEN": "[[HH_CONFIRM]]"
      },
      "PRE_STEP_OPTIONS": {
        "PRICE": {
          "ID": "price",
          "TITLE": "Budget beregner",
          "DESCRIPTION": "Få prisoverslag på sekunder"
        },
        "HELP": {
          "ID": "help",
          "TITLE": "Chat",
          "DESCRIPTION": "Hjælp til spørgsmål, budget og oprettelse"
        },
        "TASK": {
          "ID": "task",
          "TITLE": "Oprette en opgave",
          "DESCRIPTION": "Opret en opgave med det samme"
        }
      }
    },
    "HOW_IT_WORKS_DIALOG": {
      "TITLE": "Sådan virker det",
      "STEP_BY_STEP_TAB": "Trin for trin",
      "VIDEO_TAB": "Se video",
      "MAIN_TITLE": "Opret din opgave på få minutter",
      "STEP_1": {
        "TITLE": "Beskriv din opgave",
        "DESCRIPTION": "Du beskriver den opgave du ønsker at få løst."
      },
      "STEP_2": {
        "TITLE": "Modtag tilbud",
        "DESCRIPTION": "Du modtager typisk de første tilbud indenfor 5-10 minutter."
      },
      "STEP_3": {
        "TITLE": "Få løst din opgave",
        "DESCRIPTION": "Opgaven udføres og du betaler først, når du er tilfreds."
      },
      "CREATE_TASK_BUTTON": "Opret en opgave nu"
    },
    "BLOG": {
      "META_TITLE": "Handyhand Artikler",
      "META_DESC": "Artikler, Tips og tricks til boligen, haven og gør det selv",
      "SNIPPET_FALLBACK": "Læs mere om dette emne..."
    },
    "EARNING_AVERAGE": {
      "WEEK_TASKS": " på opgaver om ugen",
      "MONTH": "pr måned",
      "PRICE_AVG_1": "Baseret på gennemsnitspriser på",
      "PRICE_AVG_2": "opgaver. Priserne kan variere"
    },
    "EARNINGS_CALCULATOR": {
      "META_TITLE": "Freelance honorar beregner | Tjek dit potentiale",
      "META_DESC": "Opdag din potentielle indtjening som freelancer på Handyhand med vores avancerede honorar beregner! Ved at analysere gennemsnitslønninger fra tusindvis af opgaver på vores platform sikrer vi, at du får et realistisk estimat på hvad din indkomst kunne være. Er du klar til at blive din egen chef? Prøv beregneren og find ud af hvad dine evner er værd på Danmarks førende serviceplatform.",
      "TITLE": "Løn som freelancer",
      "SUB_TITLE": "Beregn hvad dit honorar kan være! Med beregneren kan du få et realistisk estimat på hvor meget du kan tjene per uge eller per måned!",
      "TXT_WRAPPER": " <p>\n Med vores freelance løn beregner kan du se, hvor mange penge du kan tjene om måneden på Handyhand! Hvis du nogensinde har undret dig over hvor mange penge du kan tjene på f.eks. at være fotograf eller måske passe kæledyr kan du få det at vide her. På den måde ved du hvad dine færdigheder er værd og hvor mange opgaver du skal klare for at nå dine økonomiske mål. \nHver dag oprettes der opgaver på Handyhand du måske har færdighederne til at løse, så hvorfor ikke tjene penge på det du er god til! Du kan helt selv bestemme om det på deltid, fuldtid eller bare engang imellem når du har lyst. Opret din bruger på vores digitale markedsplads, byd på opgaver, og kom i gang med at tjene penge idag!</p>",
      "TXT_CALC": "Vores freelance-løn-beregner giver dig muligheden for at finde ud af \n værdien af dine færdigheder",
      "TXT_1": "\n <h2>Hvad kan du bruge beregneren til?</h2>\n<p>\n Mange danskere oplever at de stigende leveomkostninger påvirker deres økonomi, og der ikke er ligeså mange penge til at leve som de gjorde før. Med stigende priser på\n        boliglånsrenter, madvarer, benzin og energi kommer er der mindre penge tilovers hver måned. Det betyder altså at de fleste skal betale mere for\n        at opretholde deres levestandard, og muligvis har brug for ekstra penge til at bidrage til deres indkomst og holde trit med hverdagsudgifterne.\n      </p>\n      <p>\n       Derfor har vi lavet en freelance honorar beregner som du kan bruge til bedre at forstå hvordan du kan tjene noget ekstra på dine evner og færdigheder. Hvad end du har grønne fingre og ekspert i alt der har med havearbejde at gøre, eller om du ved præcis hvilke rengøringsmidler der skal bruges til at fjerne hvilken som helst plet er der en opgave for dig på Handyhand. Dette nye værktøj fjerner gætværket, så du bedre kan estimere dit honorar og indtjeningspotentiale og tage kontrol over din indkomst og livsstil.\n      </p>\n      <p>\n        Vil du vide, hvor meget du kan tjene? Vælg fra en af over 40 forskellige kategorier, såsom <span><a href='https://handyhand.dk/flytning/flyttemand/hh'>flyttehjælp</a></span>,\n        <span><a href='https://handyhand.dk/have/havearbejde/hh'>havearbejde</a></span> eller <span><a href='https://handyhand.dk/rengoering/hh',>rengøring</a></span>, og indtast derefter følgende:\n      </p>\n      <ul>\n        <li>\n          <p>Antal opgaver om ugen</p>\n        </li>\n        <li>\n          <p>Frekvens - ugentligt eller månedligt</p>\n        </li>\n      </ul>\n      <p>\n        ...og voilà! Beregneren bruger gennemsnittet af opgaveprisen baseret på vores markedsplads-data.\n      </p>\n",
      "USP_1": "Er du den fødte handyman?",
      "USP_2": "Brug dine færdigheder og tjen op til 35.000 om måneden med 5 opgaver \n om ugen.",
      "EARN_UP": "Tjen op til",
      "AMOUNT_28": "28.000",
      "AMOUNT_35": "35.000",
      "AMOUNT_38": "38.000",
      "MONTH": "Om måneden",
      "CLEAN_USP": "Er du skarp til at gøre rent?",
      "CLEAN_DESC": "Uanset om det er en rutine- eller slutrengøring, kan du tjene penge på\n          dine rengøringsfærdigheder og tjene op til 28.000 DKK om måneden, hvis \n du udfører 5 opgaver om ugen.",
      "GREEN_USP": "Har du grønne-fingre?",
      "GREEN_DESC": "Elsker du havearbejde, planter eller bare at være ude i naturen? Tjen\n          op til 38.000 DKK per måned med 5 havearbejdsopgaver per uge.",
      "CATEGORIES": {
        "ADMINISTRATION": "Administration",
        "AELDREHJAELP": "Ældrehjælp",
        "BOERNEPASNING": "Børnepasning",
        "BROLAEGNING": "Brolægning",
        "BYGGE_PROJEKTER": "Bygge projekter",
        "CHAUFFOER": "Chauffør",
        "DIGITALT_DESIGN": "Digitalt design",
        "DYREPASNING": "Dyrepasning",
        "ELEKTRIKER": "Elektriker",
        "FLYTTEHJAELP": "Flyttehjælp",
        "FOTOGRAF": "Fotograf",
        "FRISOER": "Frisør",
        "GULVARBEJDE": "Gulvarbejde",
        "HANDYMAN": "Handyman",
        "HAVEARBEJDE": "Havearbejde",
        "HJAELP_MOBIL_PC_TV": "Hjælp til mobil pc tv",
        "INDRETNINGSARKITEKT": "Indretningsarkitect",
        "IVAERKSAETTERHJAELP": "Iværksætter hjælp",
        "LASESMED": "Låsesmed",
        "MADLAVNING": "Madlavning",
        "MALER": "Maler",
        "MASSOER": "Massør",
        "MEKANIKER": "Mekaniker",
        "MOEBEL_REPARATION": "Møbel reperation",
        "MOEBELSAMSLING": "Møbelsamling",
        "MURER": "Murer",
        "NEDRIVNING": "Nedrivning",
        "RENGOERING": "Rengøring",
        "REPARATION_BIL_BAAD_CYKEL": "Reparation/klagøring af bil båd cykel",
        "RYDNING": "Rydning",
        "SANERING": "Sanering",
        "SERVERING_FESTHJAELP": "Servering eller anden hjælp til fest",
        "SKADEDYRSBEKAEMPELSE": "Skadedyrsbekæmpelse",
        "SMED": "Smed",
        "SYNING": "Syning",
        "TAGARBEJDE": "Tagarbejde",
        "TEKSTFORFATTER": "Tekstforfatter",
        "TOEMRER_SNEDKER": "Tømrer & snedker",
        "UNDERVISNING": "Undervisning",
        "VVS": "Vvs"
      },
      "ENGINE": {
        "EARN": "Hvor meget kan du tjene?",
        "CHOOSE_CAT": "Vælg en kategori / færdighed",
        "REQ_CAT": "Du skal vælge en kategori / færdighed",
        "W": "Med",
        "TASK_PR": "opgaver per",
        "CALC_SALARY": "Udregn din løn",
        "EARN_POS": "Du kan tjene",
        "START": "Kom i gang nu",
        "RESTART": " Genstart beregneren",
        "CALC_1": " Baseret på gennemsnitspriser på ",
        "CALC_2": "opgaver. Priserne kan variere",
        "ERROR_FETCH_TASKS": "Kunne ikke hente opgaver. Prøv igen.",
        "ERROR_NO_PRICE_DATA": "Ingen prisdata tilgængelig for denne kategori."
      }
    },
    "FAQ": {
      "Q1": "Relevante",
      "Q2": "spørgsmål",
      "Q3": "Spørgsmål og svar",
      "FULL": "FAQ - ofte stillede spørgsmål"
    },
    "HANDYHANDER_LEVELS": {
      "TITLE": "Hvordan Handyhand niveauer virker",
      "META_DESC": "Handyhand niveauer er til for at give flere fordele til dig som løser opgaver på Handyhand. Når du tjener et vist beløb på at lave opgaver, så kan du få reduceret servicegebyret på fremtidige opgaver med Handyhand niveauer.",
      "H1": "Hvordan fungerer Handyhand niveauer ",
      "H2": "Hvordan beregnes mit niveau? ",
      "H3": "Hvad er min \"udførselsrate\"?",
      "H4": "Hvad er min \"indtjening\"?",
      "H5": "Hvor kan jeg finde mere information?",
      "T1": "Handyhand niveauer er til for at give flere fordele til dig som løser opgaver på Handyhand. Når du tjener et vist beløb på at lave opgaver, så kan du få reduceret servicegebyret på fremtidige opgaver med Handyhand niveauer.",
      "T2": "Du vil blive belønnet med forskellige niveauer, når du tjener penge ved at udføre opgaver på Handyhand. Niveauerne er inddelt i bronze, sølv, guld og platin. Et højere niveau vil give et lavere servicegebyr på fremtidige opgaver.",
      "T3": "Dit niveau bestemmes af to forskellige tal:",
      "T4": "1. Din udførselsrate, dvs. hvor god du har været til at gennemføre de opgaver som du er blevet accepteret til ud fra dine 20 senest tildelte opgaver på platformen.",
      "T5": "2. Din indtjening de seneste 30 dages, dvs. hvor meget du har tjent i løbet af de sidste 30 dage.",
      "T6": "Hvert niveau har et minimumskrav for indtjening og udførselsrate. Du skal opfylde disse krav for at flytte til det tilsvarende niveau.",
      "T7": "Her ser du er gebyrsatserne for hvert niveau:",
      "T8": "Din udførselsrate er en afspejling af, hvor godt du har overholdt dine forpligtelser til dine 20 senest tildelte opgaver.",
      "T9": "Udførselsrate udregnes ved at sammenligne alle de afsluttede opgaver med alle de annullerede opgaver i de sidste 20 tildelte opgaver. På en sådan måde er der en rimelig buffer inkluderet hvis der skulle opstå uundgåelige aflysninger (Det kan jo ske!).",
      "T10": "En udførselsrate kan i øjeblikket falde ind under en af fire niveauer: Ringe, Okay, God og Fantastisk. Jo flere opgaver du udfører ud af dine 20 senest tildelte opgaver, jo bedre bliver din udførselsrate.",
      "T11": "Din indtjeningsscore er baseret på din samlede indtjening over de sidste 30 dage.",
      "T12": "Hver gang en opgave ejer frigiver betaling til dig, lægges beløbet til dit samlede beløb og vil vare ved de næste 30 dage.",
      "T13": "Du kan finde flere informationer om, hvordan niveauer og gebyrer fungerer i denne ",
      "T14": "som også inkludere ofte stillede spørgsmål. Du er velkommen til at kontakte support, hvis du har feedback eller forslag.",
      "A_1": "artikel",
      "BRONZE": "Bronze",
      "FEE_LABEL": "{{fee}} service gebyr",
      "BRONZE_COM": "Ringe udførelsesrate på seneste 20 opgaver",
      "BRONZE_EARN": "Tjen mindre end 3.800,- de seneste 30 dage",
      "SILVER": "Sølv",
      "SILVER_COM": "Okay udførelsesrate på seneste 20 opgaver",
      "SILVER_EARN": "Tjen mere end 3.800,- de seneste 30 dage",
      "GOLD": "Guld",
      "GOLD_COM": "God udførelsesrate på seneste 20 opgaver",
      "GOLD_EARN": "Tjen mere end 11.500,- de seneste 30 dage",
      "PLAT": "Platin",
      "PLAT_COM": "Fantastisk udførelsesrate på seneste 20 opgaver",
      "PLAT_EARN": "Tjen mere end 23.000,- de seneste 30 dage"
    },
    "HERO": {
      "TITLE": "Se hvad du kan tjene",
      "NEAR_Y": " nær dig",
      "NATIONAL_LINK": "{{service}} i hele Danmark",
      "NEEDS": "til alle dine behov",
      "FAST_CLEANING": "Fast rengøring?",
      "BOOKING_TEXT_2": "Få 100 kr til fast rengøring med HappyHelper med koden:",
      "BOOKING_TEXT": "Start her",
      "CODE_COPIED": "Rabatkode kopieret! Du omdirigeres nu...",
      "BOOKING": "Booking",
      "ALT": {
        "EYEBROW": "Danmarks største opgaveplatform",
        "TRUSTPILOT_EXCELLENT": "Fremragende"
      }
    },
    "LINK_CONTAINER": {
      "IN": "i",
      "SERVICES_WORD": "services",
      "JOBS_WORD": "jobs",
      "RELATED_CITIES": "Beslægtede byer",
      "OTHER": "Andre",
      "OTHER_REGIONS": "Andre regioner",
      "PLACES": "og steder",
      "SERVICES": "Relaterede services",
      "REL": "RELATEREDE"
    },
    "PRICE_REVIEW": {
      "PARAGRAPH": "Se alle anmeldelser som folk har givet dig.",
      "REPORT": "Reporter bruger",
      "LAT": "De seneste ",
      "REV": "Seneste anmeldelser",
      "GET_PRICE": "Få en pris"
    },
    "DAMAGE_COMPENSATION_LINE": {
      "TITLE": "Gratis skadegodtgørelse op til {{maxAmount}}",
      "LINK": "Sådan virker det"
    },
    "VALUE_LINE": {
      "SERVICE_COIN": "Mere for pengene",
      "SERVICE_COIN_DESC": "Spar op til 70% sammenlignet med traditionelle udbydere. Du modtager tilbud fra selvstændige håndværkere med lave driftsomkostninger, så du får mere for pengene.",
      "SERVICE_TASK": "Små og store opgaver",
      "SERVICE_TASK_DESC": "Uanset om du har brug for en lille reparation eller et større projekt, finder du den rette hjælp på Handyhand. Vi har Handyhands klar til alle typer opgaver.",
      "SERVICE_DAMAGE_COMPENSATION": "Gratis skadegodtgørelse",
      "SERVICE_DAMAGE_COMPENSATION_DESC": "Vi tilbyder gratis skadegodtgørelse, der dækker op til {{maxAmount}} i skader, så du kan være tryg når du booker en Handyhand.",
      "SERVICE_PAY": "Sikker betaling",
      "SERVICE_PAY_DESC": "Al betaling foregår kontantløst gennem en sikker forbindelse. Du betaler først, når opgaven er udført til din tilfredshed.",
      "SERVICE_BOOKING": "Service samme dag ",
      "SERVICE_BOOKING_DESC": "Har du brug for hjælp i dag? Mange af vores Handyhands er tilgængelige samme dag, så du hurtigt kan få løst din opgave."
    },
    "DEEP_LINK_BUTTONS": {
      "HOW_IT_WORKS": "Hvordan",
      "MEET_SOME_HANDYHANDS": "Hvem byder",
      "EXAMPLES": "Eksempler",
      "FAQ": "Spørgsmål",
      "PRICES_AND_REVIEWS": "Priser og anmeldelser",
      "PRICES": "Priser",
      "REVIEWS": "Anmeldelser",
      "GOOD_TO_KNOW": "Værd at vide",
      "WHY_HANDYHAND": "Hvorfor Handyhand",
      "POPULAR_ROUTES": "Populære ruter"
    },
    "GLOBAL_SEARCH_ENGINE": {
      "PLACEHOLDER": "Søg efter kategorier, guides, artikler..."
    },
    "FLOATING_CTA": {
      "BUTTON": "Få en pris på 2 minutter"
    },
    "CHECKLIST": {
      "DONE_PERCENT": "Udført:",
      "SELECT_LABEL": "Vælg tjekliste:",
      "READ_MORE": "Læs mere",
      "SEE_GUIDE": "Se guide her:",
      "CREATE_TASK": "Opret opgaven på Handyhand",
      "ADD_ITEM_PLACEHOLDER": "Nyt punkt",
      "ADD_ITEM_DESC_PLACEHOLDER": "Beskrivelse (valgfri)",
      "ADD_ITEM_BUTTON": "Tilføj punkt",
      "EDIT_MODE_SAVE": "Gem redigering",
      "EDIT_MODE_EDIT": "Rediger tjekliste",
      "PRINT_PDF": "Udskriv PDF",
      "OPTIONS": {
        "WEDDING": "Bryllup",
        "WEDDING_TODO": "Bryllups huskeliste",
        "MOVING_OUT": "Flytte hjemmefra",
        "RENTAL_MOVE_IN": "Indflytning i lejebolig",
        "GARDEN": "Have",
        "CLEANING_EQUIPMENT": "Rengøringsudstyr",
        "CLEANING_SCHEDULE": "Rengøringsplan",
        "AIRBNB_CLEANING": "Airbnb rengøring",
        "MOTORCYCLE_INSPECTION": "MC syn"
      }
    },
    "CUSTOM_CARD": {
      "READ_PRICE_GUIDE": "Læs prisguiden her",
      "SEE_ALL_PRICE_DATA": "Se alle Pris data guides her"
    },
    "GENERIC_CARD": {
      "SEE_ALL_TIPS": "Se alle tips her"
    },
    "SPONSORED_BANNERS": {
      "GO_TO_WEBSITE": "Gå til hjemmeside",
      "HEADER_PREFIX": "Sponsorerede"
    },
    "ASSOCIATED_TASKS": {
      "EXPAND_AREA_ARIA": "Udvid området"
    },
    "HOW_IT_WORKS_VIDEO": {
      "IFRAME_TITLE": "Sådan fungerer Handyhand"
    }
  },
  "GENERAL": {
    "ABOUT_US": "Om os",
    "AS_TO": "Som opgaveejer",
    "BACK": "Tilbage",
    "BEST": "De bedste",
    "COMPLETION_RATE": "Udførelserate",
    "CREATE_TASK": "Opret en opgave",
    "HELP": "Hjælp",
    "HELP_FOR": "Hvad søger du hjælp til?",
    "HELP_FOR_TXT": "Skal jeg bruge hjælp til...",
    "HELP_NOW": "Find hjælp nu gratis",
    "SEARCH_SITE_PLACEHOLDER": "Søg i hele vores site...",
    "SEARCH_SUBMIT": "Søg..",
    "HEADER_SEARCH_PLACEHOLDER": "Hvad søger du?",
    "CLEANING_ONE_OFF": "Enkelt rengøring",
    "CLEANING_SUBSCRIPTION": "Fast rengøring",
    "CLEANING_FIND": "Find rengøring",
    "DAMAGE_COMPENSATION": "Skadegodtgørelse",
    "TERMS": "Betingelser",
    "PRIVACY": "Privatlivspolitik",
    "GUIDELINES": "Retningslinjer",
    "PRESS": "Presse",
    "OFF_NOW": "Modtag bud gratis",
    "SIMILAR_TASKS_BTN": "Opret lignende opgave",
    "OFF": "Modtag bud",
    "REQUEST_OFFER": "Anmod om bud",
    "CREATE_FREE": "Opret opgaven gratis",
    "NO_TIME": "Det tager mindre end 2 minutter og er gratis!",
    "FAQ": "FAQ - ofte stillede spørgsmål",
    "REVIEW": "ANMELDELSE",
    "SERVICE_IN_CAT": "Serviceydere indenfor kategorien: ",
    "WHY_FLEX": "Fleksibilitet",
    "PREV_TASK": "Tidligere opgaver",
    "MEMBER": "Bliv medlem",
    "OFFER_N": "Hvad tilbyder",
    "SEL_TASK_TYPE": "Vælg en type opgave",
    "READ": "Læs mere",
    "INFO": "Info",
    "BEST_ASSOCIATED_USERS_SUB": "Handyhand er en markedsplads med MitID-verificerede hjælpere og ægte anmeldelser – klar til din opgave",
    "TIME": {
      "WEEK": "uge",
      "MONTH": "måned"
    },
    "WITHIN_AREA": "løser opgaver inden for \n områderne:",
    "WORTH_KNOW": "Værd at vide",
    "WHY_DESC": " Vælg de opgaver, du vil udføre for de mennesker, du er tryg ved\n                at arbejde med. Du har kontrol over din egen kalender og kan\n                selv finde den balance mellem arbejde og privatliv, der fungerer\n                for dig.",
    "BTN": {
      "CATS": "Kategorier",
      "CAT_1": "Kategorier",
      "CREATE_TASK_NOW": "Opret en opgave nu",
      "SEE_ALL": "Se alle...",
      "SEE_MORE": "Se flere...",
      "FIND_TASKS": "Se opgaver",
      "BTN_TASK4": "Prøv det nu"
    },
    "CONTROL": {
      "EXT": "Udvid",
      "HIDE": "Skjul"
    },
    "CUTS": {
      "EXPERT": ", fra eksperter nær dig.",
      "HERE": "her",
      "FIND": "Find",
      "READ_MORE_ABOUT": "Læs mere om emnet",
      "FIND_A": "Find en",
      "HELP_WITH": "Hjælp til",
      "FOR_TASK": " til opgaven",
      "NEAR_Y": " nær dig",
      "NOW": "nu",
      "H_IN": "hjælper med havearbejde i",
      "HELP_FOR": "Du kan finde hjælp til",
      "IN": "og omegn",
      "CREATE_TASK": "Opret en opgave, modtag bud og få opgaven udført"
    },
    "CTA": {
      "HELP_TASK": "Ønsker du hjælp til at løse en opgave vedr ",
      "HELP_OFFERED": " På Handyhand tilbyder private billig hjælp til at løse opgaver, du kan\n        gratis oprette din opgave her og lade handyhanderne kontakte dig med bud",
      "C_1": "Det er ",
      "C_2": "gratis",
      "C_3": "og tager 2\n  minutter.",
      "SIGN_UP_NOW": "Tilmeld dig nu"
    },
    "LOADING": {
      "CREATING_TASK": "Åbner \"opret opgave\"...",
      "REDIRECTING": "Omdirigerer til Handyhand..."
    }
  },
  "META": {
    "EARN": "Tjen penge med",
    "FIND_LOCAL": "Find lokal"
  },
  "NAVIGATION": {
    "BTN": {
      "CREATE_TASK": "Opret opgave",
      "TRY_NOW": "Prøv det nu",
      "CTA_START": "Kom igang nu",
      "BACK_TO_PLATFORM": "Tilbage til platformen"
    },
    "TXT": {
      "ABOUT_US": "Om os",
      "CREATE_TASK": "Opret en opgave",
      "HOME": "Hjem",
      "HOW_IT_WORKS": "Hvordan?",
      "LOGIN": "Login",
      "SIGN_UP": "Tilmeld",
      "SEE_TASKS": "Se opgaver",
      "SEE_ALL_TASKS": "Se alle opgaver",
      "SEARCH_SITE": "Søg på siden",
      "SEARCH_PLACEHOLDER": "Hvad søger du?"
    }
  },
  "PAGES": {
    "SECURITY_INCIDENT": {
      "META_TITLE": "Sikkerhedsmeddelelse: falske notifikationer den 1. november",
      "META_DESC": "Søndag den 1. november blev en falsk push-notifikation sendt til en del af Handyhands brugere. Se hvad der skete, og hvad du skal gøre.",
      "EYEBROW": "Sikkerhed",
      "TITLE": "Sikkerhedsmeddelelse: falske notifikationer den 1. november",
      "LEAD": "Søndag den 1. november omkring kl. 16.40 blev en falsk push-notifikation sendt til en del af vores brugere. Her kan du se, hvad der skete, og hvad du skal gøre.",
      "STATUS_TITLE": "Status: inddæmmet og under overvågning",
      "STATUS_BODY": "Vi har identificeret årsagen, fjernet de falske notifikationer, udbedret problemet og tilføjet yderligere sikkerhedsforanstaltninger. Platformen kører normalt, og vi overvåger den tæt. Vi har anmeldt hændelsen til politiet og Datatilsynet.",
      "UPDATED": "Senest opdateret: 3. november 2026",
      "WARNING_TITLE": "Giv aldrig dine betalings- eller loginoplysninger via et link eller telefonen",
      "WARNING_BODY": "Vi beder dig aldrig om adgangskode eller kortoplysninger via et link eller telefonen. Tjek webadressen grundigt, før du klikker på et link eller logger ind: Der skal stå {{domain}}. Ser den bare en smule anderledes ud, så klik ikke, og indtast ikke noget.",
      "FAQ_TITLE": "Vigtig information",
      "FAQ": {
        "ENTERED_DETAILS": {
          "QUESTION": "Jeg klikkede på linket og indtastede mine oplysninger. Hvad skal jeg gøre?",
          "LOGIN": "Hvis du har indtastet dine loginoplysninger, skal du ændre din adgangskode på {{domain}} nu, og alle andre steder, hvor du bruger denne adgangskode. Kan du ikke logge ind, så brug \"Glemt adgangskode\" på loginsiden.",
          "CARD": "Hvis du har indtastet dine kortoplysninger, skal du spærre dit kort, kontakte din bank og holde øje med uautoriserede transaktioner.",
          "CHANGE_PASSWORD": "Skift adgangskode"
        },
        "ONLY_CLICKED": {
          "QUESTION": "Jeg klikkede på notifikationen/linket, men gjorde ikke andet. Er jeg blevet kompromitteret?",
          "ANSWER": "Hvis du har klikket på linket uden at have indtastet loginoplysninger eller kortoplysninger, er du en af de berørte brugere, men dine oplysninger er sikre. Du behøver ikke at gøre noget."
        },
        "TASK_TODAY": {
          "QUESTION": "Jeg har en opgave planlagt i dag - hvad skal jeg gøre?",
          "ANSWER": "Handyhand er online igen, så du kan igen finde oplysningerne om din opgave på platformen. Vi beklager ulejligheden, mens siden var nede.",
          "CALL_BEFORE": "Kan du stadig ikke få fat i de relevante oplysninger, bedes du kontakte support på",
          "CALL_AFTER": ", så vil de forsøge at hjælpe med at formidle kontakten mellem begge parter. Vi beder om tålmodighed."
        },
        "NOT_RECEIVED": {
          "QUESTION": "Jeg har ikke modtaget en besked eller en meddelelse - hvad skal jeg gøre nu?",
          "ANSWER": "Du er ikke berørt, og du behøver ikke at gøre noget."
        },
        "SITE_NOT_WORKING": {
          "QUESTION": "Hjemmesiden/appen virker stadig ikke for mig. Hvorfor?",
          "ANSWER": "Dele af Handyhand var midlertidigt lukket som en sikkerhedsforanstaltning og er online igen nu. Virker noget stadig ikke, så genindlæs siden eller log ind igen. Fortsætter det, så kontakt support."
        },
        "WHICH_PARTS": {
          "QUESTION": "Hvilke dele af platformen var berørt?",
          "ANSWER": "Den midlertidige nedlukning omhandlede både hjemmeside og app og påvirkede profiler, opgaver og beskeder. Alt er online igen. Vi beklager ulejligheden."
        },
        "ACCOUNT_BLOCKED": {
          "QUESTION": "Er min konto spærret?",
          "ANSWER": "Nej, beskeden kom ikke fra os, og din konto er ikke spærret."
        }
      },
      "CTA_TITLE": "Har du en opgave i dag?",
      "CTA_BODY": "Kan du stadig ikke få fat i oplysningerne, så ring til support.",
      "CTA_BUTTON": "Ring {{phone}}",
      "CLOSING": "Af hensyn til brugernes sikkerhed kan vi ikke give flere oplysninger lige nu. Tak for din forståelse. Vi holder dig opdateret."
    },
    "ABOUT_US": {
      "ABOUT_DESC": "I november 2018 blev Handyhand grundlagt. Det startede med to studerende, som begge manglende en nem måde, at tjene lidt ekstra på ved siden af deres studier. Saxo, den ene stifter, driver i dag virksomheden, som består af et hold ildsjæle, som brænder for konceptet",
      "ABOUT_DESC_2": "Inspirationen til platformen opstod fra Saxos egen far, som arbejdede som altmuligmand og altid stod klar med en hjælpende hånd, når der skulle løses opgaver i eller uden for hjemmet. Sådan et menneske, mente han at alle burde have mulighed for, at hive fat i. Og sådan kom Handyhand til live",
      "ABOUT_DESC_3": "Venlige hilsner,",
      "CONTACT_US_TITLE": "Kontakt os",
      "CONTACT_US_DESC": "Du er altid velkommen til at sende os en e-mail på support@handyhand.dk eller give os et kald på 93 83 34 41, hvis du gerne vil vide mere eller har brug for hjælp.",
      "CHRIS": "Krisztian Szabo - Udvikler",
      "CHRIS1": "\"Vores mål er at skabe så meget værdi for samfundet som muligt\"",
      "HEADER_TITLE": "Om Handyhand",
      "HEADER_SUB": "Hos Handyhand har vi et ønske om at gøre det nemmere, billigere og mere sikkert, at finde hjælp til hverdagsopgaver i lokalsamfundene.",
      "MEET_TEAM": "Team Handyhand",
      "PATRICK": "Patrick Sahlgren - CTO",
      "PATRICK1": "\"Jeg elsker når jeg kan lave software, som folk faktisk kan bruge til noget\"",
      "SAXO": "Saxo Merrild - Stifter",
      "SAXO1": "\"Hvis vi kan give folk mere tid og flere penge på lommen, så har vi vundet\"",
      "TITLE": "Hvem er Handyhand?",
      "BODY_TXT_1": "Vi er en digital platform, der sikkert og nemt forbinder dig, som er født med 10 tommelfingre med din lokale altmuligmand. Fællesskab er én af vores topprioriteter, og vi sørger for at være det trygge bindeled mellem dig og de hjælpsomme sjæle.",
      "BODY_TXT_2": "Vores platform sikrer på den måde at de til tider uoverskuelige og tidskrævende opgaver lander i hænderne på den, som rent faktisk nyder at bruge sin søndag på at gøre rent, er født med lidt grønnere fingre end andre eller som blot ønsker at tjene en ekstra sjat penge på håndens arbejde. ",
      "TITLE_2": "Platformen",
      "BODY_TXT_3": "Ideen om et digitalt samlingssted for handymænd kan spores tilbage til Saxos – stifteren af Handyhand - egen barndom, hvor han mindes hans far drøne rundt på sin cykel med et værktøjsbælte om livet for at hjælpe, hvor han kunne i lokalbefolkningen. Sådan en personlig service mente han, at alle burde have mulighed for at få fingrene, og det ledte til etableringen af Handyhand.",
      "BODY_TXT_4": "I løbet af de seneste år har opgaverne på Handyhand udviklet sig fra primært at være håndværkerbaseret til at bestå af en uendelig bred vifte af hverdagens gøremål; i alt fra klipning af kæledyrets negle til samling af et IKEA-skab. Hos os er der plads til alle uanset race, køn, nationalitet, profession og evner, og kun fantasien sætter grænser for, hvad den næste opgave skal være. ",
      "TIME_LINE_TITLE": "Tidslinje",
      "STAT_MEMBERS": "medlemmer",
      "STAT_PROVIDERS": "udbydere",
      "STAT_REVIEWS": "anmeldelser",
      "USERS": "medlemmer",
      "ACQUIRED": "opkøbt",
      "TIME_LINE_SUBTITLE_1": "stiftet",
      "TIME_LINE_SUBTITLE_2": "lanceret",
      "TIME_LINE_SUBTITLE_3": "projekt",
      "TIME_LINE_1": "Virksomheden Pinploy stiftes af Saxo og én af hans daværende medstuderende fra datalogi studiet",
      "TIME_LINE_DATE_1": "November, 2018",
      "TIME_LINE_TITLE_1": "Virksomheden Pinploy stiftes",
      "TIME_LINE_2": "Serviceplatformen Pinploy lanceres som en hjemmeside - pinploy.dk",
      "TIME_LINE_DATE_2": "April, 2020",
      "TIME_LINE_TITLE_2": "Hjemmesiden lanceres",
      "TIME_LINE_3": "De to stiftere går fuldtid og dedikerer al deres tid på at udvikle platformen",
      "TIME_LINE_DATE_3": "August, 2021",
      "TIME_LINE_TITLE_3": "Fuldtid på projektet",
      "TIME_LINE_4": "Med hjælp fra Krisztian lanceres en tilhørende iOS og Android App",
      "TIME_LINE_DATE_4": "August, 2021",
      "TIME_LINE_TITLE_4": "iOS og Android APP",
      "TIME_LINE_6": "Pinploy absorberer Handyhand, den største handyman platform i Danmark, og adopterer også navnet, Handyhand",
      "TIME_LINE_DATE_6": "August, 2022",
      "TIME_LINE_TITLE_6": "Pinploy bliver Handyhand",
      "TIME_LINE_7": "Handyhand passerer 50.000 registrerede brugere på platformen",
      "TIME_LINE_DATE_7": "September, 2019",
      "TIME_LINE_8": "Handyhand rammer 100.000 brugere - en stor milepæl for platformen",
      "TIME_LINE_DATE_8": "Juli, 2022",
      "TIME_LINE_9": "Handyhand passerer 150.000 brugere og er nu tilgængeligt for alle i hele Danmark",
      "TIME_LINE_DATE_9": "August, 2023",
      "TIME_LINE_10": "En anerkendt dansk platform for rengøringsservices, der forbinder kunder med betroede, uafhængige rengøringsfolk. Opkøbt i april 2024 for at styrke begge platforme, mens deres unikke identiteter bevares.",
      "TIME_LINE_DATE_10": "April, 2024",
      "TIME_LINE_TITLE_10": "Happy Helper opkøbt",
      "TIME_LINE_11": "Handyhand passerer 200.000 brugere på tværs af platformen",
      "TIME_LINE_DATE_11": "Maj, 2024",
      "TIME_LINE_12": "Handyhand passerer 300.000 brugere og fortsætter sin stærke vækst",
      "TIME_LINE_DATE_12": "Juni, 2025",
      "TIME_LINE_13": "En platform opkøbt i november 2025, der udvider Saxo Agdesteins portefølje inden for markedspladser og servicevirksomheder.",
      "TIME_LINE_DATE_13": "November, 2025",
      "TIME_LINE_TITLE_13": "Shouter opkøbt",
      "TIME_LINE_14": "Handyhand passerer en halv million brugere - en historisk milepæl for platformen",
      "TIME_LINE_DATE_14": "Januar, 2026",
      "TIME_LINE_SUBTITLE_REBRAND": "Rebrand",
      "TIME_LINE_SUBTITLE_APP": "App",
      "TIME_LINE_CARD_TITLE_APP": "iOS og Android",
      "TIME_LINE_MILESTONE_500K_PLUS": "500K+",
      "TIME_LINE_MILESTONE_300K": "300K",
      "TIME_LINE_MILESTONE_200K": "200K",
      "TIME_LINE_MILESTONE_150K": "150K",
      "TIME_LINE_MILESTONE_100K": "100K",
      "TIME_LINE_MILESTONE_50K": "50K",
      "TIME_LINE_LOGO_ALT_SUFFIX": "logo",
      "MEDIA_TITLE": "Handyhand i medierne",
      "MEET_TEAM_TITLE": "Meet the team",
      "MEET_TITLE": "Meet the team",
      "MASCOT_TITLE": "Mød Kuno - Handyhands Maskot",
      "HOW_IT_WORKS_TITLE": "Sådan virker det",
      "HOW_STEP_1_TITLE": "Opret en opgave",
      "HOW_STEP_1_DESC": "Beskriv din opgave og modtag tilbud fra kvalificerede hjælpere i dit lokalområde.",
      "HOW_STEP_2_TITLE": "Vælg din hjælper",
      "HOW_STEP_2_DESC": "Sammenlign tilbud, læs anmeldelser og vælg den hjælper, der passer bedst til opgaven.",
      "HOW_STEP_3_TITLE": "Opgaven udføres",
      "HOW_STEP_3_DESC": "Din hjælper udfører opgaven. Betal sikkert gennem platformen når du er tilfreds.",
      "MISSION_TITLE": "Vores værdier",
      "VALUE_1_TITLE": "Tryghed",
      "VALUE_1_DESC": "Alle brugere verificeres med MitID. Vi sikrer trygge rammer for både opgavestillere og hjælpere.",
      "VALUE_2_TITLE": "Fællesskab",
      "VALUE_2_DESC": "Vi forbinder mennesker i lokalsamfundet og skaber muligheder for alle.",
      "VALUE_3_TITLE": "Fair betaling",
      "VALUE_3_DESC": "Hjælpere sætter selv deres pris. Ingen skjulte gebyrer, gennemsigtige vilkår.",
      "VALUE_4_TITLE": "For alle",
      "VALUE_4_DESC": "Uanset om du skal have klippet hæk eller samlet et skab — hos os er der plads til alle opgaver.",
      "WHY_TITLE": "Hvorfor Handyhand?",
      "WHY_1": "Danmarks største platform for hjælp i hverdagen med over {{users}} medlemmer",
      "WHY_2": "Alle hjælpere og opgavestillere verificeres med MitID for din sikkerhed",
      "WHY_3": "Sikker betaling via platformen — du betaler først når opgaven er udført",
      "WHY_4": "Gratis at oprette opgaver — du betaler kun når du accepterer et tilbud",
      "WHY_5": "Over 20.000 anmeldelser på Trustpilot med et gennemsnit på 4,5 stjerner",
      "GROWTH_TITLE": "Vores impact",
      "GROWTH_TASKS": "oprettede opgaver",
      "GROWTH_PAID": "udbetalt til hjælpere",
      "GROWTH_COVERAGE_VALUE": "Hele DK",
      "GROWTH_COVERAGE": "landsdækkende",
      "TRUSTPILOT_DESC": "Baseret på over 5.000 anmeldelser på Trustpilot",
      "PARTNERS_TITLE": "Betroede partnere",
      "META_TITLE": "Om holdet bag Handyhand",
      "META_DESC": "Hvem er vi og hvorfor har vi startet Handyhand? Få svar her",
      "GROWTH_PAID_VALUE": "200M+ kr.",
      "MASCOT_VIDEO_1_TITLE": "Ny lampe - Handyhand",
      "MASCOT_VIDEO_2_TITLE": "Hej nabo - Handyhand",
      "MASCOT_VIDEO_3_TITLE": "Flyttedag - Handyhand"
    },
    "APP_LANDING": {
      "META_TITLE": "Handyhand App til iOS og Android - Download",
      "META_DESC": "Tjen penge på at udføre opgaver i hjemmet med appen på vores platform - Del opgaver du gerne vil ' +\n        'have udført, byd på opgaver og bliv opdateret omkring dine opgaver direkte på telefonen",
      "TITLE": "Gå aldrig",
      "TITLE_1": "glip af",
      "TITLE_2": "noget",
      "UPDATE_CONTENT": "Opret opgaver du skal have ordnet, giv bud og hold dig opdateret, selv når du er på farten.",
      "ON_THE_GO": "Lær app'en at kende",
      "POST_BROWSE_TASKS_HEADLINE": "Opret eller find opgaver",
      "POST_BROWSE_TASKS_CONTENT": "Opret opgaver, som du ønsker hjælp til, eller byd på opgaver, som du ønsker at udføre.",
      "COMMUNICATION_HEADLINE": "Nemt at kommunikere med andre",
      "COMMUNICATION_CONTENT": "Når du accepterer et bud fra en Handyhand, eller selv er blevet valgt til at udføre en opgave, er det muligt at kommunikere direkte gennem private beskeder.",
      "PAYMENTS_HEADLINE": "Hurtig og sikker betaling",
      "PAYMENTS_CONTENT": "Gennem vores sikre betalingssystem, vil du eller din Handyhand blive betalt for det udførte arbejde.",
      "DOWNLOAD_NOW": "Hent appen nu",
      "MOCKUPS": {
        "TASK_NEW": {
          "HEADER": "Ny opgave",
          "HERO_SUB": "I dag er en god dag at få løst opgaver!",
          "HERO_TITLE": "Hvilken opgave skal du have løst?",
          "QUESTION_WHAT": "Hvad skal du have løst?",
          "EXAMPLE_INPUT": "fx. male værelse",
          "QUESTION_WHEN": "Hvornår skal det ordnes?",
          "PILL_SPECIFIC_DATE": "Specifik dato",
          "PILL_BEFORE_DATE": "Før dato",
          "PILL_FLEXIBLE": "Fleksibel",
          "TOGGLE_TIMESLOT": "Det skal være et specifikt tidsrum",
          "NEXT_BUTTON": "Næste"
        },
        "TASK_INPUT": {
          "QUESTION_WHAT": "Hvad skal du have ordnet?",
          "EXAMPLE_INPUT": "Hjælp til at flytte sofa",
          "QUESTION_WHEN": "Hvornår?",
          "PILL_ON_DATE": "På dato",
          "PILL_BEFORE_DATE": "Før dato",
          "PILL_FLEXIBLE": "Fleksibel"
        },
        "CHAT": {
          "NAME_1": "Lars",
          "NAME_2": "Jens",
          "INITIAL_1": "L",
          "INITIAL_2": "J",
          "MSG_1": "Hej Lars, vi har ryddet så I kan løfte sofaen ind via stuedøren – skulle gerne gøre det lidt nemmere",
          "MSG_2": "Hej Jens, megafedt, det gør det helt sikkert meget nemmere. Vi er der kl. 8.30!"
        },
        "PAYMENT": {
          "HEADER": "Betaling",
          "STATUS": "Betaling sendt",
          "AMOUNT": "500 kr",
          "LABEL": "Til Handyhanderen",
          "RECEIPT_DATE": "I dag · 09.41"
        }
      }
    },
    "BLOG": {
      "TITLE": "Handyhand Artikler",
      "DESC": "Artikler, Tips og tricks til boligen, haven og DIY."
    },
    "CREATE_TASK": {
      "STEPS_BUDGET_GENERATOR": {
        "TITLE": "Budgetestimat",
        "ELAB_QUESTIONS": "Uddybende spørgsmål",
        "SUB_V1": "Baseret på mere end {{tasks}} opgaver har vi udarbejdet et estimat for dit projekt. Modtag forskellige tilbud og beslut dig for det bedste. Den endelige pris fastsættes først, når du vælger et tilbud.",
        "FAILED": "Det lykkedes os ikke at udregne dit budget. Prøv at indtaste en mere detaljeret opgavebeskrivelse eller vælg selv et budget og se evt. lignende opgaver.",
        "CALCULATING_BUDGET": "Udregner budget",
        "CALCULATING_BUDGET_DESCRIPTION": "Der udregnes budgetestimat for opgaven baseret på over {{tasks}} andre opgaver - vent venligst...",
        "LOW": "Lav",
        "AVG": "Gennemsnit",
        "HIGH": "Høj",
        "AI_WELCOME": "Hej, jeg Handyhands AI-budgetestimeringsværktøj!..",
        "DESC": "Beskrivelse",
        "BUDGET": "Budget",
        "SUB_TASKS": "Under Opgaver",
        "EXPLAIN": "Forklaring",
        "YOUR_ESTIMATE": "Dit budgetestimat",
        "YOUR_ESTIMATE_DESC": "Du kan selv indtaste et budget, hvis du ikke er enig i estimatet.",
        "FAILED_PREDICT": "Kunne ikke estimate budget ud fra opgavebeskrivelsen. Indtast venligst et budget manuelt.",
        "FINISHING_UP": "Arbejder, vent venligst, det kan tage op til 30 sekunder",
        "CREATE_TASK": "Opret opgave",
        "CREATE_TASK_TIP": "*Du kan redigere detaljerne efter du har klikket på 'Opret opgave'",
        "LOADING_STEPS": {
          "LOADING": {
            "ANALYZING_TASK_TYPE": "Analyserer typen af opgave...",
            "ESTIMATING_TASK_SCOPE": "Estimerer opgavens omfang...",
            "COMPARING_TASKS": "Sammenligner med {{tasks}}+ opgaver...",
            "FINDING_PRICES_RUNNING_TASKS": "Finder priser på lignende opgaver...",
            "ESTIMATING_BUDGET_TASK": "Estimerer budgettet på din opgave..."
          },
          "COMPLETED": {
            "ANALYZING_TASK_TYPE": "Opgaven er analyseret",
            "ESTIMATING_TASK_SCOPE": "Opgavens omfang er estimeret",
            "COMPARING_TASKS": "{{tasks}}+ opgaver sammenlignet",
            "FINDING_PRICES_RUNNING_TASKS": "Priser på lignende opgaver fundet",
            "ESTIMATING_BUDGET_TASK": "Budget estimat udregnet"
          }
        },
        "CERTAINTY_SCORE": {
          "TITLE": "Budgetnøjagtighed",
          "LOW": "LAV",
          "MEDIUM": "MEDIUM",
          "HIGH": "HØJ"
        },
        "FAQ": "Spørgsmål og svar",
        "FAQ_1": "Hvordan virker budgetberegneren?",
        "FAQ_1_1": "Vi anvender kunstig intelligens til nøjagtigt at estimere et budget for dit projekt. Ved at sammenligne dit projekt med over {{tasks}} lignende opgaver anvender vores avancerede algoritmer data til at fastsætte priser. Vi tager hensyn til projektets omfang for at udarbejde et skræddersyet budget baseret på disse oplysninger.",
        "FAQ_2": "Hvordan er mit budget udregnet?",
        "FAQ_2_1": "[INDSÆT BUDGET UDREGNINGS FORKLARING HER]",
        "FAQ_3": "Hvorfor skal min opgave have et budget?",
        "FAQ_3_1": "Et budget hjælper Handyhanders med at forstå, hvad du forventer at betale for opgaven. Det hjælper også med at sikre, at du får realistiske bud på opgaven.",
        "FAQ_4": "Hvad hvis jeg ikke er enig i budgettet?",
        "FAQ_4_1": "Du kan altid ændre budgettet, hvis du ikke er enig i det. Du kan også vælge at indtaste dit eget budget.",
        "FAQ_SIMILAR_1": "Lignende opgaver andre har fået udført ",
        "FAQ_SIMILAR_2": "og",
        "FAQ_SIMILAR_3": "Se nogle eksempler på rigtige opgaver andre har oprettet på platformen og hvilke bud de har modtaget",
        "SIMILAR_TASKS": {
          "DESC": "Beskrivelse",
          "PRICE": "Gns. bud på opgaven",
          "PRICE_TOOLTIP": "Gennemsnittet af alle bud givet på opgaven",
          "TIME": "Beregnet tid opgaven tager",
          "TASK_OWNER": "Oprettet af",
          "HOURS": "timer",
          "HOUR": "time",
          "NUMBER_OF_OFFERS": "Bud på opgaven",
          "MATCH_DEGREE": "Matchningsgrad",
          "MATCH_TOOLTIP": "Hvor godt din opgave matcher med denne opgave"
        }
      }
    },
    "HH_LANDING": {
      "BASED_ON": "Baseret på",
      "BECOME": "Bliv Handyhander",
      "JOB_CATEGORIES_TITLE": "Find job efter kategori",
      "JOB_CATEGORIES_DESC": "Se de opgavetyper, hvor der oftest er arbejde at få, og kom i gang der, hvor dine evner passer bedst.",
      "EARN": "Tjen penge",
      "HEADER_TITLE": "Bliv din egen chef",
      "HEADER_TITLE_1": "Tjen op til 35.000 kr om måneden på Handyhand",
      "HEADER_DESC": "Hvordan kan man tjene nogle ekstra eller hurtige penge? Svaret er Handyhand.dk. Ønsker du at finde arbejde og tjene penge online, så er Handyhand det rette sted for dig. Med vores online hjemmeside/platform kan du hurtigt finde arbejdsopgaver som passer dig.",
      "HEADER_CTA_TEXT": "Opret. vælg, færdig.",
      "HEADER_CTA_PRIMARY_BUTTON": "Kom igang nu",
      "HEADER_CTA_SECONDARY_BUTTON": "Se opgaver",
      "HOW_IT_WORKS_FIND_TITLE": "Find en opgave",
      "HOW_IT_WORKS_FIND_DESC": "Find en opgave som du gerne vil udføre og giv et bud",
      "HOW_IT_WORKS_CREATE_TITLE": "Opret din profil",
      "HOW_IT_WORKS_CREATE_DESC": "Opret en profil på Handyhand gratis",
      "HOW_IT_WORKS_DO_TITLE": "Udfør opgaven og bliv betalt",
      "HOW_IT_WORKS_DO_DESC": "Udfør opgaven og modtag betaling og en anmeldelse",
      "FEATURE_SECTION_TITLE": "Hvorfor skal jeg bruge Handyhand?",
      "FEAT_1": "Sikker betaling",
      "FEAT_2": "HandyhandPay sikrer at du altid bliver betalt for dit arbejde uden at risikerer at blive snydt eller skal indrive selv.",
      "FEAT_3": "Forbedre dit omdømme",
      "FEAT_4": "Med Handyhand får du en profil hvor du kan optjene badges, stjerner, anmeldelser med mere, som du kan vise frem eller linke til.",
      "FEAT_5": "Nemt og hurtigt",
      "FEAT_6": "Du kan hurtigt og nemt finde arbejde i nærheden af dig. Platformen giver et nemt og hurtigt overblik over ledige opgaver nær dig.",
      "META_TITLE": "Bliv Handyhand | Find jobs | Småjobs | Arbejde | deltids arbejde | Handyhand™",
      "META_DESC": "✅Tjen penge med Handyhand. ✅ Danmarks bedste markedsplads for jobs & opgaver. ✅ Alt fra handymen til Rengøring. ✅ Find arbejde nu og tjen penge online.",
      "PLATFORM_RIGHT_TITLE": "Find opgavemuligheder gratis",
      "PLATFORM_RIGHT_DESC": "Bliv Handyhander og kom i gang med at tjene penge med det samme. Få notifikationer i vores app hver gang der er en opgave der matcher dine færdigheder og interesser.",
      "PLATFORM_TASK_TITLE": "Fastsæt din pris",
      "PLATFORM_TASK_DESC": "Har du fundet en opgave som er lige dig? Fastsæt din pris og send et tilbud. Du kan justere og diskutere tilbuddet med kunden senere.",
      "PLATFORM_COMM_TITLE": "Udfør opgaven, få betaling - så enkelt er det",
      "PLATFORM_COMM_DESC": "Nar du angiver at en opgave er udført bliver der automatisk afsendt en anmodning om betaling og så snart opgavestiller godkender vil pengene blive frigivet i systemet.",
      "TESTOMONIALS_TITLE": "Andre Handyhands",
      "WHY_HANDYHAND_TITLE": "Opret din profil og find opgaver i dag",
      "WHY_HANDYHAND_DESC1": "Det tager få minutter at oprette en profil og så kan du være i gang med at finde din første opgave",
      "WHY_HH_TITLE": "Tjen ekstra penge med Handyhand",
      "WHY_HH_DESC1": "Tjen hurtigt og nemt med Handyhand.dk! Uanset om du er handyman, håndværker, lektiehjælper, eller rengøringsassistent, find fleksible jobs, der passer til dig.",
      "WHY_HH_DESC2": "Vores platform forbinder dig med arbejdsopgaver - nogle Handyhanders tjener over 35.000 om måneden!",
      "WHY_HH_DESC3": "Platformen er perfekt for både professionelle, studerende eller pensionister, der søger ekstra indtægter. Tag kontrol over din tid og indtjening med Handyhand!",
      "WHY_HH_CTA_TEXT": "Klar til at blive en del af fælleskabet?",
      "WHY_HH_BUTTON": "Bliv Handyhander",
      "USP_1": "Tjen op til 35.000 kr om måneden",
      "USP_2": "Hurtigt at komme i gang - tjen penge fra første dag",
      "USP_3": "Automatisk skadegodtgørelse der sikre både dig og kunden",
      "USP_4": "Brug vores app til at styre det hele",
      "USP_5": "Du bestemmer hvilke jobs du vil tage - og hvor ofte",
      "QUESTION_1": "Klar til at være din egen chef?",
      "QUESTION_2": "Er du en handyman, rengøringsekspert eller kan tilbyde en helt tredje service, er Handyhand den deleøkonomiske platform hvor du lokalt kan slå opgaver op eller finde jobs.<br/><br/>  Handyhand gør det nemt at små eller mellemstore jobs online igennem vores platform. Hjælp folk med at få løst opgaver i hjemmet og tjen penge i dag på små opgaver."
    },
    "HOW_IT_WORKS": {
      "HERO": {
        "REVIEWS": "Anmeldelser",
        "TASK_COMPLETED": "Opgave udført",
        "TASK_PAID": "Betaling sendt",
        "TIME_2_MIN_AGO": "2 min siden",
        "TIME_1_MIN_AGO": "1 min siden"
      },
      "MOCKUPS": {
        "TITLE_DUEDATE": {
          "QUESTION_WHAT": "Hvad skal du have ordnet?",
          "EXAMPLE_INPUT": "Hjælp til at flytte sofa",
          "QUESTION_WHEN": "Hvornår?",
          "PILL_ON_DATE": "På dato",
          "PILL_BEFORE_DATE": "Før dato",
          "PILL_FLEXIBLE": "Fleksibel"
        },
        "LOCATION": {
          "QUESTION_WHERE": "Hvor er opgaven?",
          "OPTION_IN_PERSON": "Kræver fremmøde",
          "OPTION_ONLINE": "Online"
        },
        "DESCRIPTION": {
          "TITLE": "Beskrivelse",
          "EXAMPLE_TEXT": "Jeg har købt en ny sofa der leveres til fortov, men skal have hjælp til at bære den op på 3. sal",
          "ADD_IMAGES_LABEL": "Tilføj billeder"
        },
        "BUDGET": {
          "QUESTION_BUDGET": "Hvad er dit budget?",
          "EXAMPLE_AMOUNT": "500 kr"
        },
        "GET_OFFERS": {
          "NEW_OFFERS_BADGE": "5 nye tilbud modtaget",
          "ACCEPT": "Acceptér",
          "NAME_1": "Maria",
          "NAME_2": "Jørgen",
          "NAME_3": "Frank",
          "NAME_4": "Søren"
        }
      },
      "TITLE": "Opret din opgave på få minutter",
      "CREATE_TASK": " Opret din opgave, vælg en person, få det gjort",
      "COMMUNICATION_TITLE_1": "Nemt at kommunikere",
      "COMMUNICATION_CONTENT_1": "Når du har accepteret et bud, kan du tage direkte kontakt til din Handyhand gennem private beskeder. Sammen kan I aftale nærmere og holde kontakten, indtil opgaven er løst.",
      "CLOSE": "Luk",
      "STEPS": {
        "TITLE_DUEDATE_STEP_TITLE": "Angiv hvad du vil have ordnet, og hvornår",
        "TITLE_DUEDATE_STEP_DESC": "Beskriv kort hvad du gerne vil have ordnet og angiv hvornår du ønsker opgaven udført",
        "LOCATION_STEP_TITLE": "Hvor skal opgaven udføres?",
        "LOCATION_STEP_DESC": "Angiv hvor opgaven skal udføres. Er det f.eks. noget der kræver fremmøde eller kan det løses online via videomøde?",
        "DESCRIPTION_STEP_TITLE": "Beskriv i korte træk hvad opgaven går ud på",
        "DESCRIPTION_STEP_DESC": "Beskrivelsen hjælper vores Handyhandere med at vurdere opgaven, så du får det bedst mulige tilbud.",
        "BUDGET_STEP_TITLE": "Vælg dit budget",
        "BUDGET_STEP_DESC": "Dette er blot et ca. estimat - den endelige pris kan du forhandle senere.",
        "GET_OFFERS_STEP_TITLE": "Modtag tilbud, og vælg den bedst egnede til at udføre opgaven",
        "GET_OFFERS_STEP_DESC": "Kig på profiler og anmeldelser og vurdér helt selv hvem du synes passer bedst til opgaven."
      },
      "DESC_CONTENT_1": "Med hundredevis af opgaver på platformen hver måned, er der god mulighed for, at udføre opgaver og tjene penge. Vælg de opgaver, som passer bedst til dig og dine kompetencer.",
      "DESC_CONTENT_2": "Med Handyhands sikre betalingssystem kan du være sikker på, at modtage din betaling når opgaven er udført.",
      "DESC_SUBTITLE_3": "Stærk skadegodtgørelse",
      "DESC_CONTENT_3": "Ved hjælp af vores skadegodtgørelses model, kan du trygt udføre opgaver gennem Handyhand. Læs mere om skadegodtgørelsen ",
      "HEADLINE": "Sådan fungerer det",
      "LIGHTBOX_BUTTON": "Videointroduktion",
      "META_TITLE": "Hvordan det virker",
      "META_DESC": "Få adgang til tusindevis af dygtige mennesker til opgaver i alle kategorier. Alt fra samling af møbler til data formidling - hyr en dygtig Handyhander i dag.",
      "PAY_TITLE": "HandyhandPay™",
      "PAY_CONTENT_1": "Med HandyhandPay™ kan du du nemt og sikkert betale din Handyhand, når du får løst en opgave gennem Handyhand. Vores betalingssystem holder på beløbet, indtil opgaven er udført.",
      "PAY_CONTENT_2": "Først når opgaven er meldt afsluttet, udbetales pengene til din Handyhand. I tilfælde af, at opgaven ikke bliver udført, vil pengene selvfølgelig blive tilbagebetalt til din konto.",
      "PAY_ICON_1": "Hurtig og sikkert",
      "PAY_ICON_2": "Kontantfri",
      "PAY_ICON_3": "Du er i kontrol",
      "SUB_HEADER_1": "Hvad skal du have ordnet?",
      "SUB_HEADER_2": "Vælg den rette til opgaven",
      "SUB_HEADER_3": "Fuldført opgave",
      "SUB_TEXT_1": "Start med at fortælle os om din opgave. Beskriv hvornår og hvor du skal have det gjort, og foreslå derefter et rimeligt budget for opgaven. Du kan dele enhver slags opgave, alt  fra rengøring til webdesign på kun to minutter – og gratis! Der er 100% uforpligtende og gratis at komme i gang.",
      "SUB_TEXT_2": "Tag et kig på profiler og anmeldelser for at vælge den bedste Handyhand til din opgave. Når du accepterer et bud, holdes din betaling sikkert med HandyhandPay, indtil opgaven er fuldført og du er tilfreds. Nu kan du sende beskeder og ringe til din Handyhand for at få detaljerne på plads.",
      "SUB_TEXT_3": "Når din opgave er fuldført, skal du blot frigive den betaling, der derefter holdes med HandyhandPay. Nu kan du skrive en anmeldelse af de Handyhands arbejde, så alle kan se det gode arbejde han/hun har udført!",
      "SUB_HEAD_TEXT": "Spar dig selv for besvær og kom igennem din to-do liste i dag ",
      "HEADER": "Alle hverdagsopgaver samlet på én platform",
      "HH_DESC": "Tjen penge med Handyhand",
      "HH_BOSS": "Vær din egen chef",
      "HERE": "her.",
      "SAFE_PAY": "Sikker betaling",
      "DOWNLOAD_APP_TITLE": "Hold dig opdateret",
      "DOWNLOAD_APP_CONTENT_1": "Med Handyhands app kan du hele tiden holde dig opdateret, selv når du er på farten. Du kan oprette opgaver, gennemgå bud eller kommunikere med din Handyhand. Du kan også byde på andres opgaver og holde øje med, om dine bud accepteres.",
      "REVIEWS_TITLE": "Bedømmelser & anmeldelser",
      "REVIEWS_CONTENT_1": "Platformen giver mulighed for, at se profiler og læse anmeldelser af vores Handyhanders. På denne måde får du de bedste forudsætninger for, at vælge den rette person til opgaven.",
      "STEP_1": "Beskriv din opgave",
      "STEP_2": "Modtag bud",
      "STEP_3": "Få løst din opgave",
      "TASKS": {
        "FURNITURE_ASSEMBLY": {
          "TITLE": "Møbelsamling",
          "DESCRIPTION": "Samle Ikea skab"
        },
        "PAINTING": {
          "TITLE": "Maler",
          "DESCRIPTION": "Male til flyttesyn"
        },
        "MOVING_ASSISTANCE": {
          "TITLE": "Flyttehjælp",
          "DESCRIPTION": "Flytte til Roskilde"
        },
        "GARDENING": {
          "TITLE": "Havearbejde",
          "DESCRIPTION": "Beskære 4 træer"
        },
        "IT_SUPPORT": {
          "TITLE": "IT support",
          "DESCRIPTION": "Windows installation"
        },
        "ELECTRICIAN": {
          "TITLE": "Elektriker",
          "DESCRIPTION": "Installere Sonos"
        },
        "CLEANING": {
          "TITLE": "Rengøring",
          "DESCRIPTION": "Ugentlig rengøring"
        },
        "MOVING_ASSISTANCE_2": {
          "TITLE": "Flyttehjælp",
          "DESCRIPTION": "Flytte indbo"
        },
        "ELECTRICIAN_2": {
          "TITLE": "Elektriker",
          "DESCRIPTION": "Opsætte lamper"
        },
        "CATERING": {
          "TITLE": "Catering",
          "DESCRIPTION": "Middag til 14"
        },
        "PLUMBING": {
          "TITLE": "VVS",
          "DESCRIPTION": "Reparere håndvask"
        },
        "CARPENTRY": {
          "TITLE": "Tømrerarbejde",
          "DESCRIPTION": "Bygge bogreol"
        },
        "DOG_WALKING": {
          "TITLE": "Hundeluftning",
          "DESCRIPTION": "Daglige gåture"
        },
        "PHOTOGRAPHY": {
          "TITLE": "Fotografi",
          "DESCRIPTION": "Familiefotografering"
        },
        "WEB_DESIGN": {
          "TITLE": "Webdesign",
          "DESCRIPTION": "Lave hjemmeside"
        },
        "TUTORING": {
          "TITLE": "Lektiehjælp",
          "DESCRIPTION": "Matematik hjælp"
        },
        "WINDOW_CLEANING": {
          "TITLE": "Vinduespudsning",
          "DESCRIPTION": "Pudse vinduer"
        },
        "LAWN_MOWING": {
          "TITLE": "Græsslåning",
          "DESCRIPTION": "Slå græsplæne"
        },
        "GRAPHIC_DESIGN": {
          "TITLE": "Grafisk Design",
          "DESCRIPTION": "Design logo"
        },
        "HANDYMAN": {
          "TITLE": "Handyman",
          "DESCRIPTION": "Små reparationer"
        }
      }
    },
    "LANDING": {
      "COMMUNITY_1": "Handyhand er en markedsplads",
      "COMMUNITY_2": "Med {{handyhanders}}+ verificerede og anmeldede virksomheder og private, der tilbyder hjælp til opgaver af enhver slags.",
      "EARN": "Tjen penge med Handyhand",
      "FOOTER_DESC": "Handyhand er et dansk markedspladsfællesskab hvor folk kan finde hjælp til opgaver af enhver slags, komme i kontakt med private handyman og lokale services eller udføre fleksible opgaver og tjene penge.",
      "FOOTER_SLOGAN": "Vi har fokus på sikkerhed, tillid og gennemsigtighed.",
      "FOOTER_COMPANY": "Virksomhed",
      "FOOTER_EXPLORE": "Udforsk",
      "HERO_USP_1": "kunder",
      "HERO_USP_2": "opgaver",
      "HERO_USP_3": "anmeldelser",
      "LANG_SWITCH": "Skift sprog til ",
      "MEET": "Mød nogle Handyhanders",
      "META_TITLE": "Få løst opgaver i dit hjem eller tjen penge på Handyhand",
      "META_DESC": "Få løst opgaver indenfor rengøring, afhentning, tømrer arbejde, vægmontering til hjemmet. Online job platform for små opgaver, opret en opgave og modtag bud fra private i dag.",
      "OWN_BOSS": "Din helt egen chef",
      "OWN_BOSS_DESC": "Er du god med dine hænder, eller måske bare en troldmand til IT? måske din næste opgaver ligger og venter på Handyhand.",
      "OWN_BOSS_USP_1": "Gratis adgang til tusindvis af opgaver",
      "OWN_BOSS_USP_2": "Ingen abonnement eller skjulte gebyrer",
      "OWN_BOSS_USP_3": "Få en ekstra indkomst når du har tid og lyst",
      "SUB_TXT": "Flytning, havearbejde, VVS, handyman og",
      "SUB_TXT_2": "meget mere.",
      "USP_MAIN_TITLE": "Hvorfor skal jeg bruge Handyhand?",
      "USP_HERO_WOMAN_ALT": "Kvinde med telefon",
      "USP_HERO_WOMAN_IMG_PATH": "private/lp/webp/lp_hero_imgs/happy_woman_with_phone.webp",
      "USP_1_DESC": "Udbetal først når opgaven er fuldført til din tilfredshed",
      "USP_2_DESC": "Vælg den rette til opgaven ud fra verificerede anmeldelser og ratings",
      "USP_3_DESC": "Dækket af vores skadegodtgørelses model, hvis der skulle opstå uheld. Læs mere om",
      "USP_3_LINK": "Skadegodtgørelse.",
      "USP_1_TITLE": "Sikker betaling",
      "USP_2_TITLE": "Verificerede anmeldelser",
      "USP_3_TITLE": "Skadegodtgørelse",
      "USP_EASY": "Nemt at bruge",
      "OR_ANYTHING": "... eller noget helt andet?",
      "USP_JOB": " Du kan begynde at søge job i nærheden af dig med det samme. Du\n kan filtrere efter placering og kategorier og få besked, når der\n                dukker op opgaver, du er interesseret i nærheden af dig.",
      "WHY_PAY_TIT": "Hurtig og sikker betaling",
      "WHY_PAY_DESC": "Vi sikrer din betaling allerede inden du starter opgaven, så du\n kan være sikker på, at pengene er der, når opgaven er fuldført.",
      "HH_PROFILE_IMG_ALT": "Handyhands profilbillede",
      "HH_NAME_1": "Carsten",
      "HH_NAME_2": "Lise",
      "HH_NAME_3": "Gustav",
      "HH_DESC_1": "Carsten har 10 års erfaring som handyman og tilbyder nu også hjemmeoptimering, fx speciallavede hylder og smarte løsninger, der giver hjemmet et personligt præg.",
      "HH_DESC_2": "Lise har 7 års erfaring med rengøring og hjælper også med organisering – fra skabe og skuffer til børneværelser, altid med struktur og overblik.",
      "HH_DESC_3": "Gustav er haveekspert og forvandler haver med landskabsdesign, smukke blomsterbede og dekorative stier til personlige fristeder.",
      "HH_TRUST": "Tillid",
      "HH_WHAT_OTHERS_SAY": "Hvad andre siger om ",
      "HH_WHAT_OTHERS_SAY_1": "Meget venlig og mødestærk. Kan klart anbefale Carsten til handyman opgaver. Tak for hjælpen!",
      "HH_WHAT_OTHERS_SAY_2": "Lise reddede mig fra kaos, da ungerne havde væltet alt ud – hun ryddede op med et smil, og børnene elskede hende.",
      "HH_WHAT_OTHERS_SAY_3": " Gjorde et flot stykke arbejde i haven og har en fed attitude. Vi vil klart bruge Gustav i haven igen.",
      "HH_TESTIMONIAL_1": "Meget venlig og mødestærk. Kan klart anbefale Carsten til handyman opgaver. Tak for hjælpen!",
      "HH_TESTIMONIAL_2": "Amanda fik styr på vores hus og var omsorgsfuld og kom til tiden. Vi vil klart benytte os af Amanda igen.",
      "HH_TESTIMONIAL_3": " Gjorde et flot stykke arbejde i haven og har en fed attitude. Vi vil klart bruge Gustav i haven igen.",
      "HH_SPECIALITY_1": "Handyman, møbelsamling, flyttehjælp",
      "HH_SPECIALITY_2": "Rengøring, hushjælp, møbelsamling",
      "HH_SPECIALITY_3": "Havearbejde, maler, hundelufter",
      "HOW_1": "Hvordan fungerer det?",
      "HOW_2": "Hvad skal du have løst?",
      "HOW_2_1": "Her finder du både professionelle håndværkere og dygtige hjælpere, klar til at løse din opgave.",
      "HOW_2_2": "Se alle kategorier",
      "HOW_4": "Gennemgå bud",
      "HOW_5": "Modtag bud fra dygtige folk og se deres profiler",
      "HOW_6": "Få det gjort",
      "HOW_7": "Vælg den rette til din opgave og få det gjort",
      "HOW_8": "Del din opgave",
      "HOW_9": "Opret og beskriv din opgave. Det er gratis at oprette",
      "HOW_10": "Videon nedenfor viser, hvordan Handyhand kan hjælpe dig med, at få løst dine hverdagsopgaver.",
      "HOW_DESC": "Beskriv din opgave og få den løst online alt til hjemmet",
      "HOW_ONLINE": "Opret en opgave og få forskellige bud og tilbud online",
      "POPULAR_CATEGORIES": "Kategorier",
      "PRICE_INDEX": "Pris data",
      "PRICE_GUIDES": "Prisguides",
      "SEE_VID": "Se hvordan",
      "HERO_IMG_ALT": "Markedsplads for opgaver i hjemmet",
      "PAUSE_ROTATION": "Sæt rotation på pause",
      "RESUME_ROTATION": "Genoptag rotation",
      "STARS": "Stjerner",
      "TO_BUTTON": "Opret opgave gratis",
      "PP_BUTTON": "Tjen penge i dag",
      "COPYRIGHT": "Copyright Pinploy ApS. - 2025 Tordenskjoldsgade 14, 1055 KBH K.",
      "FAQ": {
        "FAQ_HEADER": "Spørgsmål og svar",
        "FAQ_1_QUESTION": "Hvad koster det at bruge Handyhand?",
        "FAQ_1_ANSWER": "Det er gratis at bruge Handyhand til at finde hjælp til dine opgaver. Det eneste du skal betale for, er den hjælp du finder gennem platformen, som ofte er op til 70% billigere end håndværker prisen. Du vil både modtage bud fra private og virksomheder. Ved du ikke hvad du bør betale for en opgave, så kan du vælge muligheden 'Modtag bud', og så vil vores hjælpere give deres bud på hvad opgaven skal koste. Alt du skal gøre er at oprette din opgave, modtage tilbud og vælge din hjælper. Din hjælper betales først igennem systemet, når opgaven er færdig.",
        "FAQ_2_QUESTION": "Hvad kan jeg finde hjælp til?",
        "FAQ_2_ANSWER": " Du kan finde hjælp til stort set alt på Handyhand. Uanset om du har brug for en handyman, tømrer, rengøringshjælper, VVS'er, gartner, hundelufter, maler, murer eller noget helt andet, så kan du finde den rette person til din opgave på Handyhand.",
        "FAQ_3_QUESTION": "Hvordan bruger man Handyhand?",
        "FAQ_3_ANSWER": "Det er meget nemt at bruge Handyhand. Alt du skal gøre er at oprette en opgave ved at trykke på 'Opret opgave'. Giv en god beskrivelse af den opgave du skal have løst, hvornår der senest kan gives tilbud og hvor den skal udføres henne. Du sætter et budget som er fair og passer opgaven, eller vælger at modtage bud. Derefter er alt du skal gøre at læne dig tilbage, modtage bud og vælge din hjælper. Nemmere bliver det ikke!",
        "FAQ_4_QUESTION": "Hvordan betaler man?",
        "FAQ_4_ANSWER": "Handyhand gør det nemt og sikkert at betale for din opgave med HandyhandPay™. Når du vælger en hjælper gennem platformen, holdes din betaling sikkert i systemet, indtil opgaven er udført - og det bestemmer du hvornår den er! Først når du har meldt at opgaven er færdig, udbetales pengene til din hjælper. Skulle opgaven ikke blive udført af den ene eller den anden grund, så kan du godt annullerer opgaven og blive refunderet.",
        "FAQ_5_QUESTION": "Jeg vil gerne udføre opgaver og tjene penge, kan jeg det?",
        "FAQ_5_ANSWER": "Ja! Er du en god handyman, en skarp maler, dygtig møbelsamler eller noget helt tredje, så er det super nemt at finde opgaver nær dig. Find en opgave du har lyst til at udføre, så stil spørgsmål til opgaveejeren eller giv et bud på opgaven. Handyhand gør det nemt at få små og mellemstore jobs online igennem vores platform. Hjælp folk med at få løst opgaver i hjemmet og tjen penge i dag på små opgaver. Begynd at tjene penge i dag som Handyhander!",
        "FAQ_6_QUESTION": "Hvad med skat?",
        "FAQ_6_ANSWER": "Handyhand sender kvitteringer til både dig og din hjælper, samt gør det muligt at holde overblik over sin indtjening på platformen, og gør det dermed nemt at indberette til skat, hvilket vi stærkt opfordrer alle vores hjælpere til at gøre. ",
        "FAQ_7_QUESTION": "Få hjælp eller kontakt Handyhand Support",
        "FAQ_7_ANSWER": "Du kan få hjælp ved at besøge vores support side på https://handyhand.dk/kontakt.",
        "FAQ_8_QUESTION": "Hjælpecenter",
        "FAQ_8_ANSWER": "Handyhand har en FAQ, hvor du kan finde svar på ofte stillede spørgsmål. Du kan finde vores FAQ på https://handyhand.dk/hjaelp"
      },
      "LP1": {
        "TITLE_1": "Find hjælp til",
        "ANYTHING": "hvad som helst",
        "GARDEN": "haven ",
        "HOME": "hjemmet ",
        "MOVING": "flytningen ",
        "CLEANING": "rengøring",
        "IT": "IT-hjælp",
        "PARTY": "festen ",
        "TITLE_2": "Uforpligtende bud fra anmeldte og tiltroede eksperter på få minutter",
        "PLACEHOLDER": "Jeg skal have...",
        "HERO_USP_1": "kunder",
        "HERO_USP_2": "opgaver",
        "HERO_USP_3": "anmeldelser",
        "PAINTER": "maleren",
        "CARPENTER": "tømreren",
        "ELECTRICIAN": "el-arbejdet",
        "PLUMBING": "VVS",
        "BRICKLAYER": "murerarbejde",
        "FLOOR": "gulvet",
        "FURNITURE_ASSEMBLY": "møbelsamling",
        "FURNITURE": "møblerne",
        "APPLIANCES": "hvidevarerne",
        "CARPORT": "carporten",
        "BIKE": "cyklen",
        "HANDYMAN": "håndværk",
        "EYEBROW": "Danmarks største opgaveplatform",
        "SUBTITLE": "Beskriv din opgave, få tilbud, vælg den rette hjælper.",
        "TRUSTPILOT_ALT": "Se vores anmeldelser på Trustpilot"
      },
      "SERVICE_OPTIONS": {
        "HEADLINE": "Hvad skal du have hjælp til?",
        "HANDYMAN": "Handyman",
        "GARDENING": "Havearbejde",
        "CARPENTER": "Tømrer",
        "PLUMBING": "VVS",
        "PAINTER": "Maler",
        "WASTE_COLLECTION": "Affaldsafhentning",
        "ELECTRICIAN": "Elektriker",
        "TECHNICIAN": "IT hjælp",
        "MOVING_HELP": "Flyttehjælp",
        "FURNITURE_ASSEMBLY": "Møbelsamling",
        "CLEANING": "Rengøring",
        "WINDOW_CLEANING": "Vinduespudsning",
        "HEDGE_TRIMMING": "Hækkeklipning"
      },
      "REVIEWS_TITLE": "Se hvad andre har fået lavet",
      "REVIEWS_SUBTITLE": "Mere end {{tasks}} opgaver er allerede løst gennem Handyhand.",
      "REVIEWS_DONE_BY": "Udført af",
      "REVIEWS_RATING_LABEL": "{{rating}} ud af 5 stjerner"
    },
    "HOW_TO_GUIDE": {
      "META_TITLE": "2024 Gør det selv guides",
      "META_DESC": "Find alle vores gør det selv guides på forskellige service her."
    },
    "HUB": {
      "SCHEMA": {
        "DESC": "Artikler, tips og tricks, guides og pris overslag. "
      },
      "READING_TIME": "Læsetid",
      "GUIDE_TITLE": "Guides",
      "TIPS_TITLE": "Tips og tricks indenfor ",
      "TIPS_DESC": "Find tips og tricks til alt i hjemmet her",
      "PRICE_GUIDE_TITLE": "Prisvejledninger indenfor ",
      "PRICE_DATA_TITLE": "Pris data fra {{replace}} opgaver",
      "VERTICAL_TITLE": "Modtag gratis bud indenfor ",
      "SUB_HUB_TITLE": "Andre kategorier",
      "PRICE_DATA_DESC": "Pris data over alle slags opgaver fra Handyhand platformen",
      "SYNTHETIC_PRICE_GUIDE_TITLE": "Vejledende prisoverslag",
      "SYNTHETIC_PRICE_GUIDE_DESC": "Vi har samlet nogle vejledende prisoverslag til dig",
      "DEEPLINK_GUIDES": "Guides",
      "DEEPLINK_PRICE_GUIDES": "Prisguides",
      "DEEPLINK_TIPS_TRICKS": "Tips og tricks",
      "DEEPLINK_SERVICES": "Services",
      "LOCAL_SERVICES_LINK": "Se lokale services her",
      "MINI_SERVICES_LINK": "Se mini services her"
    },
    "TIPS_INDEX": {
      "SUB_CATEGORIES_TITLE": "Tips efter underkategori",
      "DIRECT_TIPS_TITLE": "Øvrige tips indenfor kategorien",
      "ALL_IN_PARENT": "Se alle tips indenfor",
      "H1_PREFIX": "Alle tips indenfor"
    },
    "MINI_SERVICES_INDEX": {
      "SUB_CATEGORIES_TITLE": "Mini services efter underkategori",
      "DIRECT_SERVICES_TITLE": "Øvrige mini services indenfor kategorien",
      "ALL_IN_MAIN": "Se alle mini services indenfor",
      "H1_PREFIX": "Alle Mini Services indenfor",
      "META_DESCRIPTION": "Se alle vores mini services indenfor {{category}}. Find den rette service til dit behov."
    },
    "LOCAL_SERVICES_INDEX": {
      "H1_PREFIX": "Alle lokale firmaer inden for"
    },
    "INSPIRATION": {
      "META_TITLE": "- Genvej til hurtig og billig løsning -",
      "DESC_H": "Private tilbyder billig hjælp til opgaver som vedrører ",
      "CREATE": ". Opret din opgave og få uforpligtende bud",
      "TITLE": "Her er de mest populære opgavetyper på Handyhand, inspiration til hjemmet",
      "DESC": "Oversigt liste over de opgaver som der oftest søges hjælp til på Handyhand. Hos HandyHand kan du finde en række af de mest populære opgaver, der er blevet udført i hjemmet. Vores hjemmeside er en stor kilde til inspiration for dig, der ønsker at opdatere dit hjem med nye projekter. Du kan finde alt fra mindre reparationer til omfattende renoveringer, der kan give dit hjem et helt nyt udseende. Vi har samlet en liste over de mest efterspurgte opgaver, så du kan få en idé om, hvad der er muligt i dit eget hjem. Gennemse vores udvalg af opgaver og få idéer til, hvordan du kan forbedre dit hjem og gøre det mere funktionelt og flot.",
      "HELP": "Handyhandere som tilbyder hjælp til opgaver vedr.",
      "PREV": "Inspiration fra tidligere oprettede opgaver omkring"
    },
    "DAMAGE_COMPENSATION": {
      "HEAD1": "Beskyttelse",
      "HEAD2": "Skadegodtgørelse",
      "HEAD3": "Dækket af vores skadegodtgørelse",
      "USP1": "Det er rart at være dækket, skulle uheldet være ude - derfor har vi en skadegodtgørelse til rådighed, der hjælper dig med at udføre opgaver med ro i sindet.",
      "USP2": "Handyhands skadegodtgørelse dækker eventuelle tingskade der kunne opstå under udførslen af en opgave hos tredjemand imens opgaven er undervejs.",
      "USP3": "Handyhand's skadegodtgørelse leveres af vores eget skadegodtgørelses hold - så du altid kan føle dig tryg, når du får hjælp gennem Handyhand.",
      "INFO": "Din opgave er dækket af vores skadegodtgørelse",
      "HEADLINE": "Handyhand Skadegodtgørelse",
      "SUB_HEADLINE_1": "Vi er her for dig",
      "SUB_P_1": "Når du får hjælp til at få løst en opgave gennem Handyhand, er du automatisk dækket af vores skadegodtgørelse.",
      "SUB_HEADLINE_2": "Stærk skadegodtgørelse",
      "SUB_P_2": "Vores skadegodtgørelse giver dig tryghed og ro i sindet, når du får hjælp gennem Handyhand.",
      "INTRO_HEAD_1": "Dækning",
      "INTRO_TEXT_1": "Handyhands skadegodtgørelse dækker skader for op til {{maxAmount}} til eventuelle tingskade der kunne opstå under udførslen af en opgave hos tredjemand imens opgaven er undervejs. Dette i tillæg til andre forsikringer du eller serviceudbyderen har.",
      "HERO_SUB": "Når du får løst en opgave gennem Handyhand, er du automatisk dækket af vores skadegodtgørelse – uden ekstra omkostninger.",
      "CHIP_COVERAGE": "Dækning op til {{maxAmount}}",
      "CHIP_AUTOMATIC": "Automatisk dækket",
      "TOC_TITLE": "På denne side",
      "META_TITLE": "Skadegodtgørelse – dækning op til {{maxAmount}}",
      "META_DESC": "Læs om Handyhands skadegodtgørelse: hvad der er dækket, hvordan du anmelder en skade, og hvilke beløbsgrænser og frister der gælder.",
      "TERMS": {
        "INTRO": {
          "P1": "Når du booker en opgave via Handyhand-platformen, kan du være omfattet af vores skadegodtgørelsesordning efter nedenstående vilkår. Ordningen er en begrænset, frivillig godtgørelse fra Handyhand og er ikke en forsikring eller en garanti, og den ændrer ikke på, at aftalen om arbejdet indgås direkte mellem dig og udføreren.",
          "P2": "Handyhands skadegodtgørelsesordning kan yde godtgørelse på op til {{maxAmount}} pr. opgave for visse pludselige og uventede tingsskader, der opstår under udførelsen af en opgave booket og betalt gennem Handyhand. Ordningen er et supplement til eventuelle almindelige forsikringer hos opgaveejer og handyhander og er underlagt de vilkår, begrænsninger og undtagelser, der fremgår nedenfor.",
          "P3": "Med \"tingsskade\" menes fysisk skade på løsøre, inventar, bygninger eller andre materielle genstande. Ordningen dækker ikke rene formuetab, driftstab, tabt arbejdsfortjeneste eller andre indirekte tab."
        },
        "HOW_IT_WORKS": {
          "TITLE": "Hvordan fungerer skadegodtgørelsen?",
          "P1": "Du kan være omfattet af skadegodtgørelsesordningen, når opgaven er booket og betalt gennem Handyhand, og skaden opstår under selve udførelsen af arbejdet.",
          "P2": "Ordningen gælder alene i de perioder, hvor arbejdet faktisk udføres. Skader, der opstår efter dette tidspunkt, er ikke omfattet, selv om opgaven endnu ikke er markeret som afsluttet.",
          "P3": "Skaden skal anmeldes senest 14 dage efter, at opgaven er markeret som udført eller annulleret."
        },
        "COVERAGE": {
          "TITLE": "Hvad dækker skadegodtgørelsen?",
          "P1": "Handyhands skadegodtgørelse gælder for visse tingsskader, der direkte skyldes et pludseligt og enkeltstående uheld under arbejdet.",
          "P2": "Ordningen dækker ikke skader, der skyldes mangelfuld udførelse, fejlinstallation, forkert arbejdsmetode, utilstrækkelig faglig kunnen eller manglende overholdelse af gældende regler og instruktioner."
        },
        "LIMITS": {
          "TITLE": "Beløbsgrænser",
          "LEAD": "Følgende beløbsgrænser gælder for skadegodtgørelsesordningen:",
          "ITEMS": {
            "MAXIMUM": "Maksimal godtgørelse: {{maxAmount}} pr. opgave.",
            "MINIMUM": "Skader under {{minAmount}} behandles ikke.",
            "DEDUCTIBLE": "Der foretages et fradrag på {{deductibleAmount}} på alle skadesgodtgørelser.",
            "DOCUMENTED_LOSS": "Godtgørelse kan aldrig overstige det dokumenterede økonomiske tab.",
            "INDIRECT_LOSS": "Der ydes ikke godtgørelse for indirekte tab eller følgeskader."
          }
        },
        "COVERED_EXAMPLES": {
          "TITLE": "Eksempler på skader, der kan være dækket:",
          "ITEMS": {
            "PAINT": "Maling spildt på gulvet under maling af vægge.",
            "SHELF": "En hylde tabes under monteringen og knækker.",
            "MOVING_BOX": "En flyttekasse tabes, og indholdet bliver beskadiget.",
            "WINDOW": "En rude knuses under ind- eller udflytning af møbler.",
            "BUILDING": "Skader på bygningsdele, f.eks. puds, vægge, dørkarme eller gulve, forårsaget af et pludseligt uheld under opgavens udførelse."
          }
        },
        "NOT_COVERED": {
          "TITLE": "Hvad er ikke dækket af skadegodtgørelsen?",
          "ITEMS": {
            "AUTHORISATION": "Skader, der opstår, hvis udføreren ikke har de påkrævede autorisationer eller tilladelser til arbejdet, f.eks. vådrums- eller el-arbejde.",
            "TASK_DESCRIPTION": "Skader, der opstår som følge af forkerte eller misvisende opgavebeskrivelser fra din side som kunde.",
            "INTENT": "Skader forårsaget med vilje af udføreren.",
            "GROSS_NEGLIGENCE": "Skader som følge af grov uagtsomhed fra din side. <em>Grov uagtsomhed refererer til en væsentlig afvigelse fra normal, ansvarlig adfærd – for eksempel at ignorere åbenlyse risici eller fortsætte arbejdet efter at være blevet klart bedt om at stoppe.</em>",
            "WORKMANSHIP": "Skader og tab, der skyldes mangelfuld udførelse, fejlinstallation, forkert arbejdsmetode, utilstrækkelig faglig kunnen eller manglende overholdelse af gældende regler og instruktioner.",
            "INDIRECT_LOSS": "Indirekte tab, driftstab, afledte økonomiske tab eller følgeskader, der opstår som konsekvens af den oprindelige skade."
          },
          "P1": "For opgaver, hvor lovgivningen kræver autorisation eller særlig godkendelse, er det kundens ansvar at sikre, at udføreren besidder den nødvendige autorisation. Manglende autorisation kan medføre, at skadegodtgørelse ikke ydes."
        },
        "SETTLEMENT": {
          "TITLE": "Reparation, ombytning eller økonomisk godtgørelse – hvad gælder?",
          "P1": "Handyhand afgør efter en konkret vurdering, om der skal ydes økonomisk godtgørelse på baggrund af reparation eller ombytning. Ved vurderingen lægges der blandt andet vægt på reparationsmulighed, omkostninger og genstandens alder og stand.",
          "P2": "Handyhand foretager en konkret vurdering af en anmeldelse på baggrund af den modtagne dokumentation. Det er kunden, der skal sandsynliggøre skadens omfang, årsag og værdi."
        },
        "PRIVATE_INSURANCE": {
          "TITLE": "Har jeg stadig brug for en privat forsikring?",
          "P1": "Ja, vi anbefaler, at du fortsat har din egen private forsikring, da skadegodtgørelsesordningen kun dækker udvalgte skader relateret til opgaven og er underlagt beløbsgrænser og undtagelser.",
          "P2": "Hvis der opstår en skade, kan det være relevant også at anmelde den til din egen forsikring og/eller udførerens forsikring, afhængigt af situationen. Du kan samtidig anmelde skaden til Handyhand, og vi guider dig i, hvilken dokumentation der typisk er nødvendig i forhold til ordningen.",
          "P3": "Vi håber, at alt går glat med den opgave, du har booket! Hvis du har spørgsmål til skadegodtgørelsesordningen eller har brug for hjælp til at anmelde en skade, er du altid velkommen til at kontakte os."
        },
        "HOW_TO_APPLY": {
          "TITLE": "Hvordan søger jeg skadegodtgørelse?",
          "P1": "<strong>Inden du søger skadegodtgørelse, skal opgaven være enten afsluttet eller annulleret på Handyhand-platformen.</strong>",
          "P2": "Når opgaven er afsluttet eller annulleret, skal skaden anmeldes hurtigst muligt via Handyhands <a href=\"{{applicationUrl}}\">ansøgningsformular</a> og senest 14 dage efter, at opgaven er afsluttet eller annulleret.",
          "P3": "<strong>Vær opmærksom på, at hvis du afslutter opgaven, bliver betalingen frigivet og udbetalt til serviceudbyderen.</strong> Når midlerne først er udbetalt, kan Handyhand ikke tilbagehente dem fra serviceudbyderen.",
          "P4": "Hvis du mener, at der er opstået en skade, eller at opgaven ikke bør afsluttes, bør du derfor ikke afslutte opgaven, før situationen er afklaret. I stedet kan du <a href=\"{{cancellationUrl}}\">anmode om annullering</a> eller kontakte Handyhand for hjælp.",
          "P5": "Hvis annulleringen bestrides, og I ikke kan finde et kompromis, kan du læse mere om <a href=\"{{disputeUrl}}\">Handyhands konfliktproces</a>. Konfliktprocessen kan tage op til 14 dage. Handyhand kan ikke garantere en løsning, men kan hjælpe med at gennemgå sagen og foreslå et kompromis.",
          "CHECKLIST": {
            "TITLE": "Det skal du have klar, når du søger",
            "LEAD": "For at vi kan behandle din skadesanmodning så hurtigt og korrekt som muligt, bør du have følgende klar, inden du udfylder formularen:",
            "ITEMS": {
              "TASK": "Oplysninger om den relevante opgave, f.eks. opgavens titel eller link til opgaven.",
              "DESCRIPTION": "En kort og konkret beskrivelse af, hvad der skete, hvornår skaden opstod, og hvordan skaden hænger sammen med opgavens udførelse.",
              "PHOTOS": "Billeder eller anden dokumentation, der tydeligt viser skaden og dens omfang.",
              "COMMUNICATION": "Eventuel kommunikation med serviceudbyderen om skaden, hvis den kan hjælpe med at belyse, hvad der er sket.",
              "VALUE": "Dokumentation for genstandens eller skadens værdi, f.eks. kvittering, faktura, vurdering eller anden relevant dokumentation.",
              "REPAIR_COST": "Dokumentation for reparations- eller udskiftningsomkostninger, f.eks. tilbud, vurdering eller faktura.",
              "OWN_INSURANCE": "Hvis skaden er anmeldt til din egen forsikring, bør du også have relevant dokumentation herfra klar, f.eks. afgørelse, selvrisiko eller anden relevant information."
            },
            "NOTE_PROPERTY": "Hvis skaden vedrører fast ejendom eller bygningsdele, f.eks. puds, vægge eller gulve, kan et håndværkertilbud eller en faglig vurdering ofte bruges i stedet for en oprindelig købspris.",
            "NOTE_REPAIR": "Hvis genstanden potentielt kan repareres, kan vi bede om et reparationstilbud – eller en faglig vurdering, der bekræfter, at reparation ikke er mulig eller økonomisk forsvarlig.",
            "OUTRO": "Handyhand vurderer sagen på baggrund af den dokumentation, du sender ind. Det er derfor vigtigt, at du beskriver skaden så konkret som muligt og vedhæfter den dokumentation, der kan sandsynliggøre skadens årsag, omfang og værdi."
          }
        },
        "REAL_CASES": {
          "TITLE": "Eksempler på sager fra virkeligheden",
          "LEAD": "For at gøre det lettere at forstå, hvad vi dækker, har vi samlet en række eksempler baseret på tidligere afgørelser. Husk, at hver sag vurderes individuelt ud fra den indsendte dokumentation.",
          "APPROVED": {
            "TITLE": "Hvad vi typisk godkender: Pludselige uheld",
            "ITEMS": {
              "DROPPED": "Tabte genstande: En udfører taber en tung genstand ned på en kogeplade, som splintrer.",
              "HANDLING": "Skader under håndtering: En plade eller et panel knækker pludseligt, fordi det vælter eller tabes under selve arbejdet.",
              "ASSEMBLY": "Kosmetiske uheld ved montering: Nye møbler får dybe ridser eller skrammer, fordi værktøj eller dele skrider ud under samlingen.",
              "MOVING": "Flytteskader: Et møbel får et slag eller en skramme, mens det bæres gennem en døråbning eller op ad en trappe."
            }
          },
          "REJECTED": {
            "TITLE": "Hvad vi typisk afviser: Dårlig udførelse eller manglende autorisation",
            "ITEMS": {
              "INSTALLATION": "Fejlmontering og dårligt håndværk: En vask eller et armatur installeres forkert, hvilket fører til en utæthed. Dette betragtes som mangelfuld udførelse, ikke et uheld.",
              "FORESEEABLE": "Forudsigelige konsekvenser: Støv fra slibning eller savning spreder sig i huset. Dette er en naturlig følge af arbejdsprocessen og kunne være undgået med afdækning.",
              "WEAR": "Gamle skader og korrosion: En rørskade opdages efter rengøring, men tekniske undersøgelser viser, at skaden skyldes mange års tæring og rust.",
              "METHOD": "Forkert metode: Der opstår ridser eller pletter, fordi udføreren har brugt en forkert slibemetode eller anvendt et forkert rengøringsmiddel på en sart overflade.",
              "CONSEQUENTIAL": "Følgeskader af fejl: En motor eller maskine bryder sammen, fordi en reparation ikke blev udført korrekt. Dette betragtes som en konsekvens af mangelfuld udførelse og ikke som et pludseligt uheld under arbejdet.",
              "ASBESTOS": "Arbejde med asbest uden autorisation: Skader eller forurening opstået under arbejde med asbest afvises, hvis udføreren ikke har den lovpligtige autorisation. Det er dit eget ansvar som kunde at sikre, at udføreren kan fremvise et gyldigt autorisationsbevis, før arbejdet påbegyndes."
            }
          },
          "NOTE_PARTIAL": "Hvis en skade både skyldes et dækningsberettiget uheld og forhold, som ikke er omfattet af ordningen, kan Handyhand efter en konkret vurdering begrænse godtgørelsen til den del af skaden, der direkte kan henføres til det dækningsberettigede uheld."
        }
      }
    },
    "PRICE_GUIDE": {
      "PRICE_GUIDE": "Pris guide",
      "INDICATIVE_PRICES": "Vejledende priser",
      "LOW": "Lav",
      "MEDIUM": "Median",
      "HIGH": "Høj",
      "RELATED": "Relaterede artikler",
      "META": "Prisvejledninger",
      "META_TITLE": "Prisvejledninger Handyhand 2025",
      "META_DESC": "Find alle vores prisvejledninger på forskellige services her. Få et bud online til hjælp fra i hjemmet til huset og haven.",
      "SIMILAR_TASKS": "Lignende opgaver tjekket",
      "AVERAGE_OFFERS": "Gns. tilbud per opgave",
      "AVERAGE_PRICE": "Gns. bud for opgaver",
      "SIMILAR_TASKS_TITLE": "Lignende opgaver",
      "AVG_OFFER_SIMILAR_TASK": "Gns. bud",
      "OFFERS": "Tilbud",
      "LOCATION": "Sted",
      "BUDGET": "Budget",
      "CREATED_AT": "Oprettet den",
      "DESCRIPTION": "Beskrivelse",
      "TASK_EXAMPLE": "Eksempel fra en rigtig opgave",
      "TASK_EXAMPLE_DESC": "Her er et eksempel på en rigtig opgave, der blev løst på Handyhand,",
      "TASK_EXAMPLE_DESC_2": "Dette er en god måde at få en idé om, hvad andre har betalt for en lignende opgave.",
      "CALCULATE_PRICE": "Prøv prisberegner",
      "FROM_LOCATION": "Fra",
      "TO_LOCATION": "Til",
      "DISTANCE": "Afstand",
      "STAIRS": "Trapper",
      "ELEVATOR": "Elevator",
      "NO_STAIRS": "Ingen trapper",
      "KM": "km",
      "ACCESSIBILITY": "Tilgængelighed",
      "PEOPLE_WHO_COMPLETE": "Folk der udfører lignende opgaver",
      "COMPLETED_TASKS": "udførte opgaver",
      "AVERAGE_RATING": "Gennemsnitlig bedømmelse",
      "NO_RATING": "Ingen bedømmelse endnu",
      "RELATED_GUIDES": "Lignende Pris Guides",
      "SPECIALIZES_IN": "Specialiserer sig i",
      "AI_OVERVIEW": {
        "TITLE": "Pris sammenligning ud fra Handyhand opgaver",
        "DESCRIPTION": "Med over 65.000 prisguider, har vi den mest komplette prisoversigt på internettet. Find prisen for din opgave på under 2 sekunder.",
        "SEARCH_PLACEHOLDER": "Søg i vores Pris overslag...",
        "SHOW_ALL": "Vis alle",
        "LOADING_GUIDES": "Indlæser prisguider...",
        "SEE_ALL": "Se alle",
        "SERVICES": "services",
        "SEARCHING": "Søger"
      }
    },
    "SEO_CATEGORIES": {
      "TITLE": "Kategorier",
      "META_TITLE_JOBS": "Find jobs og opgaver i alle kategorier",
      "META_DESC_JOBS": "Med vores online online platform, kan du hver dag finde nye opgaver indenfor dit felt og tjene penge-",
      "META_TITLE_JOBS_LOCAL": "Find Lokale Jobs",
      "META_DESC_JOBS_LOCAL": "Find og ansøg om lokale jobs i dit område med Handyhands platform",
      "META_TITLE_VERTICAL": "Få løst dine opgaver i hjemmet",
      "META_DESC_VERTICAL": "Ønsker du privathjælp? Få hjælp fra private til at løse dine opgaver i huset og haven ✓33% lavere priser ✓Hurtigt og nemt",
      "META_TITLE_SERVICES_LOCAL": "Lokale Services",
      "META_DESC_SERVICES_LOCAL": "Find pålidelige lokale tjenester og serviceudbydere i dit område.",
      "DESC": "Uanset om du har brug for hjælp til reparationer, installationer, vedligeholdelse eller renovering, har vi en kategori til dig. Vores kategorier spænder over forskellige områder som VVS, elektricitet, snedkerarbejde, maleri, havearbejde, rengøring, flytning og meget mere. Uanset om du har et lille eller stort projekt, kan du finde en kategori, der passer til dine behov.",
      "EARN_H1": "Find freelance jobs og opgaver - Tjen penge i dag",
      "EARN_SUB": "Handyhand er Danmarks bedste jobmarkedsplads for alle slags job, fra handyman til rengøringsassistenter til gartnere. Tilmeld dig nu og tjen penge!"
    },
    "TIPS": {
      "BROWSER_TITLE": "Tips og tricks | Handyhand",
      "TITLE": "Find tips og tricks til alt i hjemmet her",
      "TIPS": "Tips og tricks alle dine projekter",
      "SEARCH": "Søg blandt 6000+ forskellige tips her..."
    },
    "AI_PRICE_GUIDES_INDEX": {
      "H1_PREFIX": "Pris Data Guides for",
      "INTRO_PART_1": "Find en detaljeret prisoversigt for opgaver inden for",
      "INTRO_PART_2": ", der hjælper dig med at estimere omkostninger og træffe velinformerede beslutninger, ud fra oversigt af data fra vores platform.",
      "LOADING": "Loading price guides...",
      "EMPTY": "Ingen Pris Data Guides fundet i denne kategori.",
      "BREADCRUMB_INDEX": "Pris Data Guides Index",
      "META_TITLE_PREFIX": "Pris data for",
      "META_DESC_PREFIX": "Find data fra opgaver indenfor",
      "META_DESC_SUFFIX": " for at hjælpe dig med at estimere omkostninger og træffe informerede beslutninger."
    },
    "AI_PRICE_DATA_OVERVIEW": {
      "BREADCRUMB": "Pris data",
      "META_TITLE": "Pris data over opgaver indenfor Handyman, Havearbejde og {{tasks}}+ forskellige opgaver",
      "META_DESC": "Se pris data over opgaver som håndværkere og handyman har udført på Handyhands markedsplads, bla. tømrer, murer, "
    },
    "PRESS_ROOM": {
      "INTRO": "Presseteamet hos Handyhand hjælper journalister og andre som har brug for interviews, statistikker, baggrundsinformation, fotos mv.",
      "IMAGE_SECTION_WORKERS": "Billeder af folk der udfører arbejde med Handyhand",
      "IMAGE_SECTION_TEAM": "Billeder teamet bag Handyhand",
      "IMAGE_SECTION_PLATFORM": "Billeder fra platformen"
    },
    "EARNINGS_CALCULATOR_IMAGES": {
      "FEMALE_HANDYMAN": "kvindelig handyman",
      "TOOL_ICON": "værktøjs ikon",
      "BOY_CLEANING": "dreng der gør rent",
      "CLEANING_ICON": "rengørings icon",
      "GARDENER": "havemand"
    },
    "HOW_IT_WORKS_PAGE": {
      "HERO_ALT": "handyman markedsplads deleøkonomi platform find opgaver online i danmark"
    },
    "PRIVACY_POLICY": {
      "ADDRESS_LINE": "København K 1055",
      "COOKIE_SETTINGS_BUTTON": "Skift cookie-indstillinger",
      "COOKIE_SETTINGS_UNAVAILABLE": "Cookie-banneret kunne ikke åbnes. Hvis du bruger en adblocker eller en privatlivsudvidelse, så tillad dette websted og prøv igen, eller slet dine cookies for webstedet og genindlæs siden: banneret vises igen ved dit næste besøg."
    },
    "HANDYHANDER_LANDING": {
      "ALT_EARN": "platform tjen penge",
      "ALT_CARPENTER": "Handyhander tømre"
    },
    "LANDING_TASK_EXAMPLES": {
      "OWNER_ALT": "Opgaveejer for løst opgaver online"
    },
    "ACCOUNT_DELETION": {
      "TITLE": "Sletning af konto",
      "INTRO_TEXT": "For at slette din Handyhand-konto, følg trinene nedenfor:",
      "STEP_1": "Log ind på den konto, du ønsker at slette",
      "STEP_2": "Tryk på knappen i øverste højre hjørne med dit navn og profilbillede",
      "STEP_3": "Tryk på \"Kontoindstillinger\"",
      "STEP_4": "Rul helt ned i bunden af siden",
      "STEP_5": "Tryk på \"Slet profil\"",
      "STEP_6": "Bekræft sletningen ved at trykke på \"Ja\""
    },
    "VERTICAL": {
      "AVG_PRICE": "Gennemsnitspris på ",
      "FLEX_PRICE": "Fleksibel pris",
      "BEST_OFF": "Vælg det bud som passer dig bedst!",
      "REVIEW_TITLE": "Gennemsnitlig anmeldelser af",
      "REVIEW_SUB": "Baseret på",
      "REVIEWS": "Anmeldelser",
      "LOC_EXPERT": "Lokale eksperter",
      "SELECT_EXPERT": "Vælg en lokal ekspert hvorend du er i Danmark.",
      "MORE_TASKS": "Se flere opgaver",
      "OFFER_NOW": "Få gratis bud nu",
      "OFFER_NOW_COMPANY": "Få bud fra lignende virksomheder",
      "OFFER_NO_TIME": "Bud på ingen tid",
      "REC_OFFER": "Modtag bud på at lave din opgave på ingen tid!",
      "DESC_TASK_2": "Udfyld en kort formular og modtag bud fra private og virksomheder ",
      "TASKS_CAT": "Find opgaver indenfor kategorien",
      "EARN_H1": "Find freelance jobs og opgaver - Tjen penge i dag",
      "TIME": "Det tager kun 2 minutter, og så er det gratis",
      "TIME_2": "Det tager kun 2 minutter, og så er det gratis",
      "TRUE_REVIEWS": "Ægte anmeldelser",
      "RELATED_SERV": "Related Services",
      "REVIEW_SELF": "Bedøm selv - alle opgaver får en anmeldelse!",
      "EARN_SUB": "Handyhand er Danmarks bedste jobmarkedsplads for alle slags job, fra handyman til rengøringsassistenter til gartnere. Tilmeld dig nu og tjen penge!",
      "SEARCH_JOB": "Søg arbejde",
      "JOB_TASK_AROUND": "Se hvilke opgaver folk vil have ordnet nær dig...",
      "FIND_JOBS": "Find jobs indenfor",
      "FIND_JOBS_2": "kategorien. Betalende arbejde med opgaver indenfor",
      "MIT_ID": "Mit ID verificeret",
      "FACEBOOK": "Facebook verificeret",
      "DIGITAL_ID": "Digital ID verificeret",
      "BANK": "Bank verificeret",
      "MOBILE": "Mobil verificeret",
      "COMPANY": "Virksomhed verificeret",
      "TOP_STAR_REVIEW": "10+ femstjernede anmeldelser",
      "BADGE_HEADER": "Verifikationer",
      "BADGES": {
        "WHAT_ARE_BADGES": "Hvad er verifikationer?",
        "BADGES_DESCRIPTION": "Verifikationer vises, når visse ID-dokumenter og kvalifikationer er verificeret. Det er en vigtig funktion, der hjælper med at fortsætte med at bygge tillid i vores community.",
        "READ_MORE": "Læs mere om verifikationer",
        "HERE": "her",
        "MIT_ID_DESCRIPTION": "Denne verifikation indikerer, at en person har verificeret deres identitet ved hjælp af MitID. MitID er Danmarks digitale underskriftsløsning, der giver sikker godkendelse og digitale underskriftsmuligheder. Ved at verificere med MitID demonstrerer brugere deres officielle identitet og får adgang til sikre digitale tjenester.",
        "BANK_DESCRIPTION": "Denne verifikation indikerer, at en persons bankkonto er blevet verificeret. Bankverificering sikrer sikre finansielle transaktioner og tilføjer et ekstra lag af tillid til platformen. Verificeringsprocessen bekræfter, at brugeren har legitim adgang til den angivne bankkonto.",
        "MOBILE_DESCRIPTION": "Denne verifikation indikerer, at en persons mobilnummer er blevet verificeret. Ved at bekræfte deres ejerskab af mobilnummeret sikrer de en sikker og pålidelig forbindelse med vores platform. Verificeringsprocessen er simpel og ligetil. Vi sender en SMS-verifikationskode til medlemmets mobilnummer for at bekræfte dets autenticitet. Dette sikrer, at nummeret faktisk ejes af medlemmet og tilføjer et ekstra lag af sikkerhed til deres konto.",
        "COMPANY_DESCRIPTION": "Denne verifikation indikerer, at en virksomhed er blevet verificeret på vores platform. Virksomhedsverificering sikrer, at forretningen er legitim og registreret, hvilket giver brugerne tillid til, at de arbejder med en verificeret forretningsenhed. Verificeringsprocessen omfatter kontrol af virksomhedsregistrering, kontaktoplysninger og andre relevante forretningsdetaljer.",
        "TOP_STAR_REVIEW_DESCRIPTION": "Denne verifikation indikerer, at en bruger har modtaget 10 eller flere 5-stjernede verificerede anmeldelser på deres profil. Denne præstation demonstrerer exceptionel servicekvalitet og pålidelighed, hvilket viser, at flere kunder har haft konsekvent positive oplevelser. Brugere med dette badge har bevist deres evne til at levere høj kvalitetsarbejde og opretholde kundetilfredshed."
      },
      "PRICE_SUGGESTER_TITLE": "Prisberegner",
      "PRICE_SUGGESTER_DESC": "Beskriv din opgave og modtag et onlineestimat ud fra de bedst bedømte udbydere, på under 1 minut",
      "OR": "Eller",
      "WHY": {
        "1": "Hvorfor hyre en",
        "2": "med Handyhand?",
        "EASE": "Handyhand gør det nemt at finde en",
        "WITHIN_CAT": "til at hjælpe med din opgave indenfor kategorien",
        "OTHER_USERS": "Andre brugere fra",
        "FOUND_LABOUR": "fandt for eksempel en dygtig og billig",
        "HELP": "til at hjælpe med opgaver som:",
        "USP_1": "Med Handyhand kan du altså nemt finde hjælp fra de bedste og mest prisdygtige",
        "IN_ZIP": "i post nr:",
        "PRICE_IN_CAT": "Prisen på opgaver indenfor kategorien",
        "PRICE_RES": "kan variere efter dine behov. De fleste opgaver i denne kategori modtager dog som regel uforpligtende tilbud i prislejet"
      },
      "MINI_VERTICAL": {
        "STATS": {
          "TITLE": "Statistikker",
          "TASKS_COMPLETED": "Opgaver gennemført i år",
          "AVERAGE_OFFERS": "Gennemsnitlige tilbud per opgave",
          "AVERAGE_PRICE": "Gennemsnitlig tilbudspris",
          "FOOTER": "Statistikker fra de seneste opgaver på Handyhand over de sidste 4 år."
        }
      }
    },
    "NOT_FOUND": {
      "TITLE": "Siden blev ikke fundet",
      "LINKS_HEADER": "Find hvad du leder efter"
    }
  },
  "TOAST_MESSAGES": {
    "WARNING": {
      "TITLE": "Din opgave skal have en titel",
      "DESC": "Din opgave skal have en beskrivelse på min. 25 bogstaver"
    }
  },
  "TOOLS": {
    "PRICE_SUGGESTER": {
      "CALC_PRICE": "Beregn prisestimat",
      "CALC_ESTIMATE": "Udregner estimat",
      "HEADER": "Prisberegner",
      "INTRO_DESC": " Beskriv din opgave og modtag et onlineestimat ud fra de bedst bedømte udbydere, på under 1 minut",
      "ESTIMATE": "Estimat",
      "MIN": "Min. 25 anslag",
      "INTRO": "Opgaver andre fik løst til et lignende budget",
      "ONLY": "*Kun på Handyhand",
      "PAY": "Betalt:",
      "DESC": "BESKRIVELSE",
      "MORE_RES": "Vis flere resultater",
      "TASK_COMP": "fik bud på denne opgave",
      "STEP_1": "Beskriv din opgave",
      "STEP_2": "Hvor og hvornår",
      "STEP_3": "Modtag et onlineestimat på sekunder",
      "USP_1": "Baseret på {{tasks}}+ opgaver",
      "USP_2": "Bruger AI til at udregne pris",
      "USP_3": "Matcher med rigtige opgaver",
      "TITLE_LABEL": "Opgavens titel",
      "DESCRIPTION_LABEL": "Beskriv din opgave",
      "TITLE_PREFIX": "Opgavens titel, f.x ",
      "TITLE": "Opgavens titel, fx Hjælp til at flytte sofa",
      "DESCRIPTION": "Vær så præcis i din beskrivelse som muligt",
      "TIPS_TITLE": "Tips til at få udregnet et mere præcist bud",
      "RELOAD_TIPS": "Indlæs flere tips",
      "LOADING_TIPS": "Indlæser tips...",
      "RELOAD_TIPS_TOOLTIP": "Opdater din beskrivelse for at se nye tips"
    }
  },
  "PLACEHOLDERS": {
    "TO": "til",
    "I_CHAR": "i",
    "I": "Indholdsfortegnelse",
    "REL_ART": "Udforsk flere Artikler i kategorien:",
    "REVIEW": "Seneste Anmeldelse",
    "VERIF": "Verificeringer",
    "SIM_TASKS": "Lignende opgaver indenfor: ",
    "STARS": "stjerner"
  },
  "FOOTER": {
    "LINK_APP": "App",
    "LINK_BLOG": "Blog",
    "LINK_UPDATES": "Opdateringer",
    "FREELANCE_CALCULATOR": "Freelance lønberegner",
    "HEAD_CAT_LINKS": {
      "HANDYMAN": {
        "LABEL": "Handyman"
      },
      "GARDENING": {
        "LABEL": "Havemand"
      },
      "MOVING": {
        "LABEL": "Flyttemand"
      },
      "CLEANING": {
        "LABEL": "Rengøring"
      },
      "WASTE": {
        "LABEL": "Afhentning af affald"
      },
      "FURNITURE": {
        "LABEL": "Møbelsamling"
      },
      "ALL_CATEGORIES": {
        "LABEL": "Alle kategorier"
      }
    }
  },
  "SEO": {
    "SCHEMA": {
      "BREADCRUMB_HOME": "Hjem",
      "GUIDES_HUB_LABEL": "Guides",
      "TIPS_INDEX_NAME": "Tips-oversigt",
      "LOCAL_SERVICES_INDEX_NAME": "Lokale services-oversigt",
      "MINI_SERVICES_INDEX_NAME": "Mini services-oversigt",
      "INSPIRATION_INDEX_NAME": "Inspiration",
      "TIPS_BREADCRUMB": "Tips",
      "RECYCLING_BREADCRUMB_ROOT": "Affald",
      "RECYCLING_INDEX_TYPE_CENTERS": "Genbrugsstationer",
      "RECYCLING_INDEX_TYPE_GARDEN": "Haveaffald",
      "RECYCLING_INDEX_TYPE_OVERVIEW": "Genbrugsstationer oversigt",
      "RECYCLING_INDEX_TYPE_BULK": "Storskrald",
      "PRICE_GUIDE_MIDDLE_PRICE": "Middelpris",
      "SERVICE_SUFFIX_IN_CITY": " i {{place}}",
      "SERVICE_SUFFIX_IN_REGION": " i {{place}}",
      "DEFAULT_ARTICLE_AUTHOR": "Handyhand",
      "WRITTEN_BY": "Skrevet af",
      "LANDING_CONTACT_TYPE": "Kundeservice",
      "LANDING_AVAILABLE_LANGUAGES": ["Dansk", "Engelsk"]
    },
    "PRICE_GUIDE_ARTICLE": {
      "EDITOR_SUFFIX": " artikel",
      "GENRE": "Prisoverslag og prisvejledninger",
      "KEYWORDS": "{{category}} hjælp og pris guide vejledning 2024, online tilbud, få et overslag",
      "DESCRIPTION": "Hvor meget koster {{category}} estimat og guide til at ansætte nogen af dit hjem? Vores prisguide opdeler priserne for forskellige {{category}} ydelser."
    }
  },
  "GUIDES": {
    "AI_PRICE_GUIDE": {
      "OFFER_NAME": "{{name}} har givet bud nr. {{n}}"
    }
  },
  "STATIC_DATA": {
    "REGIONS": {
      "aarhus": "Aarhus",
      "odense": "Odense",
      "storkoebenhavn": "Storkøbenhavn",
      "nordsjaelland": "Nordsjælland",
      "bornholm": "Bornholm",
      "vestsjaelland": "Vestsjælland",
      "sydsjaelland-og-oeer": "Sydsjælland og øer",
      "fyn": "Fyn",
      "soenderjylland": "Sønderjylland",
      "midtvestjylland": "Midt/Vestjylland",
      "nordjylland": "Nordjylland",
      "oestjylland": "Østjylland",
      "drenthe": "Drenthe",
      "friesland": "Friesland",
      "guelders": "Gelderland",
      "groningen": "Groningen",
      "limburg": "Limburg",
      "south-holland": "Zuid-Holland",
      "overijssel": "Overijssel",
      "flevoland": "Flevoland",
      "north-holland": "Noord-Holland",
      "utrecht": "Utrecht",
      "zeeland": "Zeeland",
      "north-brabant": "Noord-Brabant"
    }
  },
  "TERMS_AND_CONDITIONS": {
    "TITLE": "Vilkår og betingelser",
    "TOC_TITLE": "Indholdsfortegnelse",
    "SECTIONS": {
      "1": {
        "TITLE": "1. INDLEDNING",
        "TOC": "1. INDLEDNING",
        "P1": "1.1 Ved anvendelse af ydelserne på hjemmesiden under domænet www.handyhand.$$domain$$ accepterer du som medlem følgende forretningsbetingelser (”Forretningsbetingelserne”).",
        "P2": "1.2 Driften af hjemmesiden https://handyhand.$$domain$$ varetages af Pinploy ApS, CVR-nr. 40 02 18 92, Siljangade 6, 2300 København S. Handyhand kan kontaktes via $$contactUrl$$.",
        "P3": "1.3 Forretningsbetingelserne anvender følgende definitioner:",
        "DEFINITIONS": {
          "PAYMENT_ACCOUNT": "”Betalingskontoen” betyder den konto, betalingsfunktion eller betalingsinfrastruktur hos den til enhver tid anvendte tredjepartsbetalingsprocessor, aktuelt Stripe, som anvendes til reservation, betaling, tilbagebetaling og udbetaling i forbindelse med Opgaver",
          "HANDYHAND": "”Handyhand” betyder domænet www.handyhand.$$domain$$ og virksomheden bag, Pinploy ApS, CVR nr. 40 02 18 92",
          "HANDYHAND_PLATFORM": "”Handyhand Platformen” betyder platformen under Handyhand, hvor Opgaver udbydes",
          "HANDYHANDER": "”Handyhandee” betyder et Medlem, som udfører en Opgave",
          "HANDYHAND_SERVICES": "”Handyhand Services” betyder formidlingen af Opgaven mellem Opgaveejer og Handyhandee",
          "MEMBER": "”Medlem” betyder brugere med aktivt medlemskab hos Handyhand, herunder en samlebetegnelse for Handyhandee og Opgaveejer",
          "TASK": "”Opgave” betyder en annonce angående en ydelse, som Opgaveejer ønsker udført, oprettet på Handyhand Platformen",
          "TASK_OWNER": "”Opgaveejer” betyder et medlem som opretter en Opgave",
          "TASK_CONTRACT": "”Opgavekontrakt” betyder kontrakten mellem Handyhandee og Opgaveejer om udførelsen af en Opgave",
          "TASK_PRICE": "”Opgaveprisen” betyder den aftalte pris mellem Handyhandee og Opgaveejer.",
          "SERVICE_FEE": "”Forbindelsesgebyr” betyder Handyhands vederlag/gebyr for at stille Platformen til rådighed samt udførelsen af Handyhand Services."
        }
      },
      "2": {
        "TITLE": "2. MEDLEMSKAB",
        "TOC": "2. MEDLEMSKAB",
        "P1": "2.1 Adgangen til at benytte Handyhand Platformen er udelukkende for Medlemmer, og anvendelse af platformen forudsætter således medlemskab af Handyhand.",
        "P2": "2.2 Medlemmer af Handyhand kan aftale varetagelsen af Opgaver ved brug af Handyhands platform.",
        "P3": "2.3 Medlemskab af Handyhand anses for gyldigt etableret ved:",
        "P3_LIST": {
          "1": "(a) Medlemmets accept af disse Forretningsbetingelserne for Handyhand",
          "2": "(b) Medlemmets korrekte indtastning af medlemsoplysninger (navn, adresse og e-mailadresse) i Handyhands medlemsprofil. Et Medlem kan til enhver tid under menuen “Rediger profil” og “Indstillinger” foretage ændringer af eller slette sine medlemsoplysninger. Ved sletning af medlemsoplysninger, som er en forudsætning for at blive medlem af Handyhand, anses medlemskabet automatisk for ophørt."
        },
        "P4": "2.4 Medlemmet modtager i forbindelse med tilmeldingen en bekræftelse, som sendes til Medlemmets oplyste e-mailadresse.",
        "P5": "2.5 For at få adgang til at oprette Opgaver eller ansøge om at udføre Opgaver, skal Medlemmet validere sin e-mailadresse.",
        "P6": "2.6 Handyhand kan afslå, begrænse, suspendere eller opsige et medlemskab, hvis der foreligger en saglig grund, herunder væsentlig eller gentagen overtrædelse af Forretningsbetingelserne, ulovligt indhold, svig, misbrug af Platformen eller betalingssystemet, chikane, sikkerhedsrisici, overtrædelse af lovgivning eller adfærd, der væsentligt skader Platformens drift, andre Medlemmer eller Handyhand. Handyhand giver Medlemmet en begrundelse for beslutningen senest samtidig med, at beslutningen træder i kraft, medmindre Handyhand efter lovgivningen er forhindret heri, eller medmindre begrundelsen vil kompromittere sikkerheden på Platformen eller en igangværende undersøgelse. Ethvert Medlem kan bringe sit medlemskab til ophør uden varsel under menuen ”Indstillinger”.",
        "P7": "2.7 Alene personer over 18 år kan oprettes som Medlemmer.",
        "P8": "2.8 Medlemmer skal være en fysisk person, men kan specificere i deres profil, at de repræsenterer en virksomhed.",
        "P9": "2.9 Handyhand kan nægte en person at registrere sig som Medlem eller kan begrænse, suspendere, modificere eller opsige et eksisterende Medlems profil, hvis betingelserne i punkt 2.6 eller 8.4.1 er opfyldt. For erhvervsdrivende Handyhandees gives som udgangspunkt mindst 30 dages forudgående varsel ved permanent opsigelse eller væsentlig begrænsning af adgangen til Platformen, medmindre en lovlig undtagelse finder anvendelse, herunder ved ulovligt indhold, svig, sikkerhedsrisiko, gentagne overtrædelser eller anden tvingende grund.",
        "P10": "2.10 Det er gratis at registrere og oprette sig som Medlem på Handyhand. Der opkræves ingen betaling for at oprette og dele en Opgave, eller for andre Medlemmer at tilgå, anmelde og tilse indhold på Handyhand Platformen, herunder at dele Opgaver."
      },
      "3": {
        "TITLE": "3. HANDYHAND-PLATFORMEN OG INDGÅELSE AF OPGAVEKONTRAKTER",
        "TOC": "3. HANDYHAND-PLATFORMEN OG INDGÅELSE AF OPGAVEKONTRAKTER",
        "P1": "3.1 Handyhand stiller Handyhand Platformen til rådighed for, at Opgaveejere kan oprette og offentliggøre Opgaver.",
        "P2": "3.2 Handyhand’s ydelser består således i den løbende drift og vedligeholdelse af Handyhand Platformen, med henblik på formidling af kontakt mellem Medlemmer, herunder Opgaveejere og Handyhandees.",
        "P3": "3.3 Handyhandees kan afgive et tilbud som svar på en offentliggjort Opgave. Nogle dele af tilbudsoplysningerne kan gøres offentligt tilgængelige, herunder for internetbrugere, der ikke er Medlemmer.",
        "P4": "3.4 Opgaveejer kan til enhver tid tilbagekalde eller ændre en offentliggjort Opgave, inden Opgaveejer accepterer et tilbud fra en Handyhandee. Handyhand forbeholder sig ret til at annullere alle tilbud på en offentliggjort Opgave, der er foretaget inden ændringen.",
        "P5": "3.5 Hvis en Opgaveejer accepterer et tilbud på Handyhand Platformen, indgås Opgavekontrakten mellem Handyhandeen og Opgaveejeren.",
        "P6": "3.6 Ved oprettelsen af Opgavekontrakten skal Opgaveejeren foranledige, at Opgaveprisen reserveres eller betales via den af Handyhand anvendte tredjepartsbetalingsprocessor, aktuelt Stripe, med henblik på afregning mellem Opgaveejer og Handyhandee. Betalingsflowet administreres efter betalingsprocessorens vilkår og gældende betalingsregulering.",
        "P7": "3.7 Handyhands formidlingsydelse anses for udført, når Opgavekontrakten indgås via Platformen, og Forbindelsesgebyret forfalder på dette tidspunkt, jf. dog punkt 11. Forbindelsesgebyret kan opkræves via betalingsprocessoren og fradrages i forbindelse med betalingsflowet, i det omfang dette er foreneligt med betalingsprocessorens vilkår og gældende lovgivning.",
        "P8": "3.8 Det præciseres, at Handyhand ikke påtager sig noget ansvar for udførelsen af Opgaven, idet Opgavekontrakten alene er bindende mellem Handyhandee og Opgaveejer.",
        "P9": "3.9 Når Opgavekontrakten er oprettet, kan Handyhandee og Opgaveejer ændre Opgavekontrakten på Handyhand Platformen. Opgaveejer og Handyhandee opfordres til at bruge Handyhands private beskedsystem til at ændre eller variere Opgavekontrakten (inklusive den aftalte pris) eller til at kommunikere på andre måder.",
        "P10": "3.10 Når Opgaven er fuldført, skal såvel Handyhandee som Opgaveejer give besked herom på Handyhand Platformen.",
        "P10_1": "3.10.1 Når Handyhandee markerer Opgaven som fuldført, får Opgaveejer en frist på 10 dage til enten at bekræfte fuldførelsen eller gøre en konkret og begrundet indsigelse via Platformen. Hvis Opgaveejer bekræfter fuldførelsen, eller hvis Opgaveejer ikke reagerer inden fristens udløb, kan betalingen frigives via betalingsprocessoren til Handyhandee med fradrag af Forbindelsesgebyret. Frigivelse af betaling efter dette punkt regulerer alene betalingsprocessen og afskærer ikke Opgaveejer eller Handyhandee fra at gøre krav gældende mod hinanden efter Opgavekontrakten, ufravigelig lovgivning eller ved kompetent klageorgan eller domstol.",
        "P11": "3.11 Efter Opgavekontrakten er afsluttet, opfordres parterne til at gennemgå og give feedback på tjenesterne på Handyhand Platformen."
      },
      "4": {
        "TITLE": "4. FORBINDELSESGEBYR",
        "TOC": "4. FORBINDELSESGEBYR",
        "P1": "4.1 Ved oprettelsen af en Opgavekontrakt skylder Handyhandee og Opgaveejer Handyhand hver for sig den respektive del af Forbindelsesgebyret, der beregnes som følger:",
        "P1_LIST": {
          "1_LABEL": "4.2 For Handyhandee:",
          "1_LINK": "https://handyhand.$$domain$$/handyhander-niveauer",
          "2": "4.3 For Opgaveejer: $$taskOwnerFeePercent$$ % af Opgaveprisen, dog maksimalt $$taskOwnerFeeMax$$"
        },
        "P2": "4.4 Forbindelsesgebyret trækkes automatisk i forbindelse med hævningen af Opgaveprisen og fradrages i de midler, der udbetales fra Betalingskontoen.",
        "P3": "4.5 Hvis en Opgave kræver, at en Handyhandee påtager sig omkostninger ved udførelsen af tjenesterne, medtages de afholdte omkostninger ikke i nogen beregning af gebyrer.",
        "P4": "4.6 Gebyrer inkluderer ikke gebyrer, der kan skyldes tredjeparts tjenesteudbydere. Alle tredjepartsudbydere betales i henhold til et Medlems særskilte aftale med den tredjepartsudbyder.",
        "P5": "4.7 Gebyrer og opkrævninger, der skal betales til Handyhand, refunderes kun i det omfang, det følger af disse Forretningsbetingelser, ufravigelig lovgivning eller Handyhands udtrykkelige beslutning i det konkrete tilfælde.",
        "P6": "4.8 Handyhand kan foretage modregning i beløb, der tilkommer et Medlem, med forbehold for at modregningen ikke vedrører midler, som efter gældende lovgivning eller betalingsprocessorens vilkår skal holdes adskilt eller beskyttet.",
        "P7": "4.9 Handyhand kan begrænse et Medlems konto, indtil alle gebyrer er betalt.",
        "P8_TITLE": "4.10 Ranking, synlighed og Handyhander-niveauer:",
        "P8_1": "4.10.1 Synligheden af Opgaver, tilbud og Handyhandees på Platformen kan afhænge af flere parametre, herunder relevans for opgavekategori, geografisk afstand, pris, tilgængelighed, svartid, gennemførelsesrate, annulleringshistorik, anmeldelser, verificeringer, Handyhander-niveau og eventuelle sikkerheds- eller kvalitetssignaler.",
        "P8_2": "4.10.2 Parametrene anvendes for at skabe relevante matches og en sikker og velfungerende Platform. Handyhand kan løbende justere parametrenes vægtning, men vil informere erhvervsdrivende Handyhandees om væsentlige ændringer i overensstemmelse med punkt 14.",
        "P8_3": "4.10.3 Hvis Handyhand giver mulighed for betalt promovering eller anden betaling for øget synlighed, vil de væsentligste forhold herom fremgå af Platformen eller særskilte vilkår."
      },
      "5": {
        "TITLE": "5. FAKTURERING",
        "TOC": "5. FAKTURERING",
        "P1": "5.1 Handyhand tilbyder via Handyhand Platformen en service, hvor der gennem Handyhand Platformen automatisk genereres fakturaer på vegne af Handyhandees, i forbindelse med modtagelse af oplysning om at Opgaven er udført.",
        "P2": "5.2 Ved accept af Forretningsbetingelserne giver Handyhandees udtrykkeligt samtykke til, at Handyhand er berettiget til på Handyhandees vegne at generere og udstede fakturaer på vegne af Handyhandees, idet sådanne fakturaer vil indeholde relevante oplysninger som den pågældende Handyhandee har indtastet i Handyhand Platformen.",
        "P3": "5.3 Genereringen af fakturaer gennem Handyhand Platformen sker alene som en teknisk og administrativ serviceydelse, og det præciseres, for god ordens skyld, at Handyhand ikke herved bliver part i det underliggende aftaleforhold mellem Handyhandee og Opgaveejer. Handyhand indestår således ikke for fakturaens indhold, rigtighed, gyldighed eller betaling, og påtager sig intet ansvar i forbindelse med fakturering, betalingsmisligholdelse eller andre forhold relateret til den pågældende Opgave.",
        "P4": "5.4 Enhver tvist, fejl eller krav vedrørende fakturaen eller den leverede ydelse skal udelukkende håndteres mellem Handyhandee og Opgaveejer.",
        "P5": "5.5 Handyhandee er selv ansvarlig for at sikre, at fakturaer udstedt på dennes vegne overholder gældende lovgivning, herunder skatte-, afgifts- og bogføringsmæssige regler. Handyhand kan ikke holdes ansvarlig for eventuelle direkte eller indirekte konsekvenser af manglende overholdelse af gældende regler angående fakturaernes indhold."
      },
      "6": {
        "TITLE": "6. BETALINGER OG TILBAGEBETALINGER VED ANNULLERING",
        "TOC": "6. BETALINGER OG TILBAGEBETALINGER VED ANNULLERING",
        "P1": "6.1 Hvis Opgavekontrakten, uanset årsag, annulleres af Opgaveejer eller af Handyhandee inden påbegyndelsen af Opgaven, er Handyhand berettiget til et annullerings- & administrationsgebyr svarende til 10% af summen Opgaveprisen, dog maksimeret til $$cancellationFeeMax$$ (”Annulleringsgebyret”).",
        "P1_1": "6.1.1 Hvis annulleringen sker før beløbet er hævet (således mens Opgaveprisen alene er reserveret), vil Handyhand foretage delvis hævning af den reserverede Opgavepris svarende til Annulleringsgebyret og frigive den resterende reservation.",
        "P1_2": "6.1.2 Hvis annulleringen sker efter beløbet er hævet, refunderes Opgaveprisen til Opgaveejer med fradrag af Annulleringsgebyret.",
        "P2": "6.2 Annulleringsgebyret afholdes af Opgaveejer, såfremt annulleringen af Opgaven sker på Opgaveejers initiativ eller kan tilskrives Opgaveejer. Den aftalte pris refunderes i så fald til Opgaveejer med fradrag af Annulleringsgebyret. En annullering af Opgavekontrakten tilskrives Opgaveejer, når:",
        "P2_LIST": {
          "1": "(a) Opgaveejer annullerer Opgavekontrakten, eller",
          "2": "(b) Opgavekontrakten annulleres i overensstemmelse med punkt 8.4.1 som et resultat af Opgaveejerens handlinger eller kontraktbrud"
        },
        "P2_1": "6.2.1 I relation til annulleringstidspunktet finder pkt. 6.1.1-6.1.2 anvendelse.",
        "P3": "6.3 Annulleringsgebyret afholdes af Handyhandee, såfremt annulleringen kan tilskrives Handyhandee. Annullering af Opgavekontrakten vil tilskrives Handyhandee, når:",
        "P3_LIST": {
          "1": "(a) Opgaveejer og Handyhandee er gensidigt enige om at annullere Opgavekontrakten; eller",
          "2": "(b) Når Opgavekontrakten annulleres af Opgaveejer efter oprigtige, men mislykkedes forsøg fra en Opgaveejer på at kontakte en Handyhandee for at få udført Opgavekontrakten; eller",
          "3": "(c) Handyhandee annullerer Opgavekontrakten; eller",
          "4": "(d) Opgavekontrakten annulleres i overensstemmelse med punkt 8.4.1 som et resultat af Handyhandees handlinger eller kontraktbrud."
        },
        "P3_1": "6.3.1 I relation til annulleringstidspunktet finder pkt. 6.1.1-6.1.2 anvendelse.",
        "P4": "6.4 Ethvert beløb, som Handyhand returnerer til en Opgaveejer på vegne af en Handyhandee i henhold til punkt 6.1, er en gæld, som Handyhandee skylder Handyhand og kan modregnes af Handyhand mod andre betalinger, der til enhver tid skyldes Handyhandee.",
        "P5": "6.5 Ethvert udestående Annulleringsgebyr, som et Medlem skylder Handyhand i henhold til punkt 6.1, kan til enhver tid modregnes af Handyhand mod andre betalinger, som Handyhand skylder Medlemmet.",
        "P6": "6.6 Hvis Opgaveejer har krav på refundering, sker refundering som udgangspunkt til det betalingsmiddel, der blev anvendt ved betalingen, medmindre Opgaveejer udtrykkeligt vælger at modtage beløbet som gemt kredit på Platformen. Opgaveejer accepterer, at det kan tage op til 14 dage for Handyhand eller betalingsprocessoren at gennemføre refunderingen. Gemt kredit kan anvendes til senere Opgaver, og Opgaveejer kan anmode om udbetaling af ubrugt gemt kredit, medmindre andet følger af ufravigelig lovgivning, betalingsprocessorens vilkår eller konkrete fradrag, som er oplyst og accepteret. Eventuelt gemt kredit, der ikke er anvendt eller krævet udbetalt af Opgaveejer, bortfalder 3 år efter, kreditten er oprettet, medmindre ufravigelig lovgivning tilsiger andet."
      },
      "7": {
        "TITLE": "7. MARKEDSFØRING",
        "TOC": "7. MARKEDSFØRING",
        "P1": "7.1 Direkte eller skjult reklame, og enhver anden form for markedsføring på Platformen fra Medlemmer på egne eller andres vegne, er ikke tilladt.",
        "P2": "7.2 Enhver handling i strid med punkt 7.1 anses som væsentlig misligholdelse af aftalen mellem Handyhand og Medlemmet. Handyhand forbeholder sig ret til at slette indhold på Platformen, og til at tage yderligere retsskridt, som Handyhand anser for nødvendige som følge af overtrædelsen af punkt 7.1."
      },
      "8": {
        "TITLE": "8. MEDLEMMERNES FORPLIGTELSER",
        "TOC": "8. MEDLEMMERNES FORPLIGTELSER",
        "P1_TITLE": "8.1 Fælles forpligtelser:",
        "P1_1": "8.1.1 Medlemmet forpligter sig til:",
        "P1_1_LIST": {
          "1": "(a) At overholde alle relevante love og regler, herunder særlige regler der måtte gælde i henhold til udførelsen af Opgaven, idet Handyhand er uden ansvar herfor.",
          "2": "(b) Kun at dele korrekte informationer på Handyhand Platformen"
        },
        "P1_2": "8.1.2 Medlemmet accepterer, at alt materiale (hvad end det er fremlagt af Handyhand, et Medlem eller tredjepart) på Handyhand Platformen ikke må bruges af tredjemand eller til andre forretningsmæssige formål uden Handyhands forudgående skriftlige tilladelse.",
        "P1_3": "8.1.3 Medlemmet må ikke bruge Handyhand Platformen til ulovlige eller umoralske formål.",
        "P1_4": "8.1.4 Medlemskabet og adgangen til Handyhand-kontoen er personlig, og Medlemmet skal bibeholde den fulde kontrol over sin Handyhand-konto til enhver tid. Medlemmet må således ikke lade andre bruge kontoen, sælge eller på anden måde overdrage kontoen eller dens indhold til andre. Dette hindrer ikke, at en Handyhandee anvender hjælpere, ansatte, underleverandører eller en afløser til udførelsen af en Opgave i overensstemmelse med punkt 8.3.6.",
        "P1_5": "8.1.5 Enhver information, oplysninger, materiale eller anden kommunikation som Medlemmet deler via Handyhand Platformen skal være korrekt, tidssvarende og opdateres i nødvendigt omfang. Medlemmet indestår for og anerkender, at der ikke afgives oplysninger i strid hermed, herunder, men ikke alene, oplysninger som:",
        "P1_5_LIST": {
          "1": "(a) Er falske, ikke sandfærdige, misledende eller vildledende,",
          "2": "(b) Kan betragtes som værende svindel, bedrageriske eller involverer salg af kopivarer eller stjålne varer,",
          "3": "(c) Overtræder nogen tredjeparts ophavsret, patent, varemærke, forretningshemmeligheder eller anden ejendomsret, intellektuel ejendom, rettigheder til reklamer, fortrolighed eller privatliv,",
          "4": "(d) Overtræder nogen lov, vedtægter, bekendtgørelser eller forskrifter (inkluderende, men ikke begrænset til, dem som dækker over eksport og import kontrol, forbrugerrettigheder, kriminel lov, antidiskrimination),",
          "5": "(e) Anses for at være ærekrænkende, truende eller chikanerende,",
          "6": "(f) Anses for at være obskøn eller indeholde materiale, som efter Handyhands opfattelse, kan anses for upassende eller ulovlig, inkluderende, men ikke begrænset til uanstændige, upassende eller ulovlige billeder; eller",
          "7": "(g) indeholder ondsindet kode, data eller sæt af instruktioner som direkte eller indirekte kan skade eller undergrave Handyhand Platformen, inkluderende, men ikke begrænset til, softwarevirus, trojanske heste, orme, tidsbomber, cancelbots, easter eggs eller anden programmerings rutiner som kan skade, modificere, slette, skadeligt blande sig med, skjult blokere, tilgå uden tilladelse eller eksproprierer ethvert system, data eller personlig information."
        },
        "P1_6": "8.1.6 Handyhand Platformen må til enhver tid bruge placeringstjenester eller kort placeringsbaseret funktionalitet. Handyhand må vise placeringen af Opgaveejere og Handyhandees, som benytter platformen. Et Medlem bør aldrig afsløre personlig information såsom fulde navn, præcise adresse, telefonnummer eller e-mail i titlen, beskrivelsen, kommentarfelter, eller andre steder, hvor der er offentligt tilgængelig kommunikation på Handyhand Platformen.",
        "P2_TITLE": "8.2 Forpligtelser for Opgaveejere:",
        "P2_1": "8.2.1 Opgaveejere er forpligtede til at stille alle nødvendige og relevante oplysninger til rådighed for, at Handyhandees kan afgive tilbud på og efterfølgende udføre Opgaver.",
        "P2_2": "8.2.2 Opgaveejere skal sikre, at Handyhandees får adgang/tilladelse til at yde services, iht. Opgavekontrakten.",
        "P2_3": "8.2.3 Opgaveejere skal orientere Handyhand om evt. ændringer i Opgavekontrakter, som medfører prisændringer i forholdet mellem opgaveejer og Handyhandee.",
        "P2_4": "8.2.4 Opgaveejere er forpligtede til at betale alle skyldige beløb til såvel Handyhand som Handyhandees rettidigt.",
        "P3_TITLE": "8.3 Forpligtelser for Handyhandees:",
        "P3_1": "8.3.1 Handyhandee skal have de fornødne kompetencer, tilladelser, certificeringer, autorisationer og i øvrigt ret til at udføre/levere de aftalte ydelser iht. Opgavekontrakter.",
        "P3_2": "8.3.2 Handyhandee skal overholde skatte- og reguleringsforpligtelser i forbindelse med enhver betaling modtaget i sammenhæng med en Opgavekontrakt.",
        "P3_3": "8.3.3 Handyhandee er forpligtet til at friholde Handyhand for ethvert krav, tab, omkostninger eller anden udgift/ulempe, som Handyhand måtte blive mødt med fra tredjemand eller Opgaveejer i forbindelse med udførelsen af Opgaven.",
        "P3_4": "8.3.4 Handyhandee må ikke, når Handyhandee leverer tjenester, opkræve en Opgaveejer nogen gebyrer eller andre betalinger i tillæg til den aftalte pris. Parterne i en Opgavekontrakt kan dog blive enige om at ændre den aftalte pris gennem Handyhand Platformen.",
        "P3_5": "8.3.5 Hvis en Handyhandee accepterer at betale nogle omkostninger forbundet med at udføre en Opgave (såsom udstyr til at udføre tjenesterne omfattet af Opgaven), er Handyhandeen selv ansvarlig for at få betaling herfor fra Opgaveejer. Handyhand påtager sig i intet tilfælde noget ansvar for sådanne omkostninger.",
        "P3_6": "8.3.6 Handyhandee indretter og beslutter i enhver henseende selv hvorledes en Opgavekontrakt udføres, og kan følgelig anvende ansatte, hjælpere, underleverandører eller en afløser til at udføre hele eller dele af en Opgave. Adgang til Handyhand-kontoen må ikke overdrages eller stilles til rådighed for andre.",
        "P3_7": "8.3.7 Handyhandee udfører Opgaver som selvstændig aktør og bestemmer selv, om, hvornår og på hvilke vilkår Handyhandee ønsker at afgive tilbud på Opgaver. Handyhand instruerer ikke Handyhandee om, hvordan Opgaven skal udføres, og Handyhandee fastsætter selv sit tilbud og sin pris over for Opgaveejer.",
        "P4_TITLE": "8.4 Overtrædelser:",
        "P4_1": "8.4.1 Hvis Handyhand vurderer, at et Medlem har overtrådt punkt 8, en Opgavekontrakt eller Forretningsbetingelserne i øvrigt, kan Handyhand træffe proportionale foranstaltninger, herunder give en advarsel, begrænse synlighed, fjerne indhold, suspendere funktioner, annullere relevante Opgaver eller tilbud, suspendere kontoen midlertidigt eller opsige medlemskabet.",
        "P5_TITLE": "8.5 Platformbeslutninger, anmeldelser og klager:",
        "P5_1": "8.5.1 Medlemmer kan anmelde indhold, Opgaver, profiler, beskeder eller adfærd på Platformen, som Medlemmet mener er ulovlig eller i strid med Forretningsbetingelserne. Anmeldelser indgives via Platformens indbyggede anmeldelsesfunktion. Er det ikke muligt, kan Handyhand kontaktes via $$contactUrl$$. Anmeldelsen bør indeholde en beskrivelse af forholdet, placeringen af indholdet og relevant dokumentation.",
        "P5_2": "8.5.2 Hvis Handyhand træffer beslutning om at fjerne indhold, begrænse synlighed, suspendere en konto, opsige et medlemskab eller på anden måde begrænse adgangen til Platformen, giver Handyhand Medlemmet en klar og konkret begrundelse for beslutningen, medmindre Handyhand efter lovgivningen er forhindret heri, eller medmindre begrundelsen vil kompromittere sikkerheden på Platformen eller en igangværende undersøgelse.",
        "P5_3": "8.5.3 Medlemmet kan rette henvendelse til Handyhand via $$contactUrl$$, hvis Medlemmet ønsker, at Handyhand genovervejer en platformbeslutning. Handyhand vil bestræbe sig på at behandle sådanne henvendelser inden for rimelig tid og kan efter en konkret vurdering fastholde, ændre eller ophæve beslutningen.",
        "P5_4": "8.5.4 For erhvervsdrivende Handyhandees gælder derudover, at Handyhand i relevant omfang angiver de væsentligste grunde til begrænsning, suspension eller opsigelse og som udgangspunkt giver forudgående varsel. Handyhand kan undlade at afgive varsling, eksempelvis ved ulovligt indhold, svig, sikkerhedsrisiko, gentagne overtrædelser eller anden tvingende grund.",
        "P5_5": "8.5.5 I det omfang Handyhand er forpligtet hertil efter gældende lovgivning, eller hvis Handyhand i det konkrete tilfælde accepterer det, kan en tvist mellem en erhvervsdrivende Handyhandee og Handyhand søges løst ved mediation. Denne bestemmelse begrænser ikke parternes adgang til domstolsprøvelse."
      },
      "9": {
        "TITLE": "9. HANDYHANDS ROLLE OG ANSVAR",
        "TOC": "9. HANDYHANDS ROLLE OG ANSVAR",
        "P1": "9.1 Handyhand anses alene for at formidle Opgaven mellem Opgaveejer og Handyhandee via Handyhand Platformen, hvorfor Handyhand ikke er aftalepart i forbindelse med udførelsen af Opgaven.",
        "P2": "9.2 Planlægningen, gennemførelsen af og ansvaret for Opgaver, påhviler alene Opgaveejer og Handyhandee. Handyhand har således intet ansvar for Opgavens udførelse og/eller henholdsvis Opgaveejers og Handyhandees rettigheder og forpligtelser i henhold til Opgavekontrakten.",
        "P3": "9.3 Medlemmet og Opgaveejer er følgelig særlig bekendt med og accepterer, at Handyhand ikke på nogen måde hæfter for eventuelle skader opstået under udførelsen af Opgaver, mangler ved udførelsen af Opgaven og/eller manglende færdiggørelse af Opgaven, jf. dog punkt 18.",
        "P4": "9.4 Medlemmet er endvidere bekendt med og accepterer, at Handyhand ikke kan drages til ansvar for andres benyttelse eller videregivelse af oplysninger på Handyhands hjemmeside.",
        "P5": "9.5 Handyhands formidlingsydelse er gennemført, når Opgavekontrakten indgås via Platformen, jf. punkt 3.7 og 11. Markering af en Opgave som færdig regulerer alene betalingsprocessen mellem Opgaveejer og Handyhandee og afskærer ikke i sig selv parterne fra at gøre krav gældende mod hinanden efter Opgavekontrakten eller ufravigelig lovgivning.",
        "P6": "9.6 Handyhand bærer intet ansvar for informationen stillet til rådighed af Platformens øvrige Medlemmer, herunder, men ikke begrænset til, Handyhandees evne til at udføre Opgaver, autorisationer, og/eller information fra Opgaveejere eller Opgaveejerens evne til at betale for de efterspurgte services.",
        "P7": "9.7 Handyhand har ingen pligt til at afgøre civilretlige konflikter eller tvister mellem Medlemmer. Handyhand kan dog administrere betalingsprocessen og facilitere en praktisk tvistproces efter punkt 10 uden derved at blive part i Opgavekontrakten eller påtage sig ansvar for Opgavens udførelse.",
        "P8": "9.8 Medlemmet forstår og accepterer, at Handyhand ikke foretager nogen form for undersøgelse eller efterforskning i relation til nye Medlemmer eller tredjeparts serviceudbydere, inden de får adgang til Handyhand Platformen, inkluderende baggrundstjek, tjek af straffeattest, verifikationer eller autoriseringen som Medlemmet har, eller nogen anden undersøgelse af Medlemmets karakter eller Medlemmets evne til at udføre opgaver, som Medlemmet på Handyhand Platformen måtte påstå at være i stand til at udføre. Medlemmet forstår og accepterer, at Medlemmet alene er ansvarligt for at udføre enhver form for relevant baggrundstjek og anskaffe referencer, anmeldelser, verifikation eller autorisationer og forsikring, inden Medlemmet lader et Medlem påbegynde arbejde eller service. Medlemmet forstår og accepterer, at Medlemmet alene er ansvarligt for at lave egne vurderinger, beslutninger og evalueringer af og omkring at vælge et Medlem til at udføre en Opgave. Medlemmet accepterer at påtage sig fuld risiko, og accepterer at fritage og skadesløsholde Handyhand for enhver form for tab, skade, ansvar, personskade, død, eller andre omkostninger som opstår i relation til servicen.",
        "P9": "9.9 Handyhand kan ikke drages til ansvar for indholdet på Handyhand Platformen; herunder særlig tekst, information eller links som er indrykket af Medlemmer i fritekstfelter på hjemmesiden.",
        "P10": "9.10 Handyhand kan ikke drages til ansvar for nogen direkte eller indirekte tab og/eller følgeskader, herunder ved manglende indtjening eller tab af data og informationer."
      },
      "10": {
        "TITLE": "10. KONFLIKTER",
        "TOC": "10. KONFLIKTER",
        "P1": "10.1 Handyhand opfordrer Medlemmer til at forsøge at løse konflikter, herunder krav om tilbagebetaling eller refusion, direkte med hinanden. Handyhand kan, i det omfang det er nødvendigt og proportionalt for at facilitere opgaveudførelse, tvistbehandling, sikkerhed eller overholdelse af lovgivning, videregive relevante kontakt- og opgaveoplysninger til øvrige Medlemmer involveret i konflikten. Yderligere oplysninger om behandling af personoplysninger fremgår af Handyhands privatlivspolitik.",
        "P2": "10.2 Hvis der opstår en konflikt mellem Medlemmerne, skal Medlemmerne samarbejde og gøre et oprigtigt forsøg på at løse konflikten.",
        "P3": "10.3 Hvis Opgaveejer gør en konkret og begrundet indsigelse inden fristen i punkt 3.10.1, kan betaling tilbageholdes midlertidigt via betalingsprocessoren, i det omfang dette er muligt efter betalingsprocessorens regler og gældende ret, mens Medlemmerne forsøger at løse tvisten. Handyhand kan anmode parterne om relevant dokumentation og kan administrere betalingsprocessen efter objektive, saglige og forholdsmæssige kriterier, herunder parternes dokumentation, Opgavens status, kommunikation på Platformen, tidligere bekræftelser, betalingsprocessorens regler, risiko for svig eller misbrug og disse Forretningsbetingelser. Handyhand træffer ikke endelig juridisk afgørelse af parternes krav mod hinanden. Hvis parterne ikke løser tvisten inden 30 dage efter indsigelsen, kan Handyhand efter forudgående meddelelse frigive reservationen og / eller tilbageføre beløbet til ejeren af opgaven. Handyhand kan forlænge perioden op til i alt 60 dage, hvis der foreligger særlige grunde."
      },
      "11": {
        "TITLE": "11. FORTRYDELSESRET",
        "TOC": "11. FORTRYDELSESRET",
        "P1": "11.1 Forbrugere har som udgangspunkt fortrydelsesret efter forbrugeraftalelovens regler i forhold til Handyhands formidlingsydelse, medmindre fortrydelsesretten bortfalder efter reglerne herom og efter den procedure, der fremgår af punkt 11.2.",
        "P2": "11.2 Ved oprettelse af en Opgavekontrakt accepterer Medlemmet, at Handyhand påbegynder levering af formidlingsydelsen inden for fortrydelsesfristens udløb. Fortrydelsesretten bortfalder, når Handyhands formidlingsydelse er leveret i henhold til Forretningsbetingelserne, på hvilket tidspunkt Handyhands Forbindelsesgebyr ikke kan kræves tilbagebetalt. Medlemmet anerkender samtidig udtrykkeligt, at fortrydelsesretten bortfalder, når Handyhands formidlingsydelse er fuldt leveret.",
        "P3": "11.3 Nærværende bestemmelse berører ikke eventuel fortrydelsesret i forholdet mellem Medlemmer, der har indgået en Opgavekontrakt."
      },
      "12": {
        "TITLE": "12. HENVENDELSER TIL MEDLEMMER",
        "TOC": "12. HENVENDELSER TIL MEDLEMMER",
        "P1": "12.1 Handyhand kan sende Medlemmer servicemeddelelser, driftsmeddelelser og meddelelser vedrørende Medlemmets konto, Opgaver, betalinger, sikkerhed og ændringer af Forretningsbetingelserne. Markedsføringshenvendelser udsendes kun, hvis Medlemmet har givet særskilt samtykke hertil, eller hvis henvendelsen i øvrigt er tilladt efter gældende lovgivning."
      },
      "13": {
        "TITLE": "13. DATABESKYTTELSE",
        "TOC": "13. DATABESKYTTELSE",
        "P1": "13.1 Handyhand behandler Medlemmers personoplysninger som beskrevet i Handyhands privatlivspolitik. Visse oplysninger, herunder navn, profiloplysninger, opgaveoplysninger, anmeldelser og relevante kontaktoplysninger, kan blive gjort tilgængelige for andre Medlemmer i det omfang, det er nødvendigt for brugen af Platformen, indgåelse og opfyldelse af Opgavekontrakter, sikkerhed, tvistbehandling eller overholdelse af lovgivning. Handyhand behandler ikke personoplysninger i videre omfang end nødvendigt til de angivne formål.",
        "P2": "13.2 For at modtage udbetalinger kan Medlemmet blive bedt om at gennemføre identitets- og kontoverifikation hos Handyhands betalingsprocessor, aktuelt Stripe. I det omfang der behandles identitetsdokumenter, sker dette efter betalingsprocessorens vilkår og Handyhands privatlivspolitik. Handyhand opbevarer ikke sådanne dokumenter i videre omfang end nødvendigt og lovligt.",
        "P3": "13.3 Handyhand vil så vidt muligt træffe de nødvendige foranstaltninger for at sikre, at Medlemmers opgivne medlemsoplysninger ikke er tilgængelige for andre Medlemmer i videre omfang end det, der er en nødvendig følge af Handyhands forretningskoncept om tilbud af Opgaver. Medlemsoplysninger videregives herudover ikke til tredjemand. Medlemmet er dog indforstået med, at medlemsoplysninger bliver brugt til interne, statistiske og anonyme bedømmelses formål.",
        "P4": "13.4 Et Medlem kan til enhver tid under menuen ”Rediger profil” foretage ændringer af sine medlemsoplysninger eller slette sin profil og dermed alt opbevaret data.",
        "P5": "13.5 Et medlem kan til enhver tid opsige sit medlemskab ved at kontakte Handyhand via $$contactUrl$$."
      },
      "14": {
        "TITLE": "14. ÆNDRINGER AF FORRETNINGSBETINGELSER",
        "TOC": "14. ÆNDRINGER AF FORRETNINGSBETINGELSER",
        "P1": "14.1 Handyhand forbeholder sig retten til at ændre Forretningsbetingelserne.",
        "P2": "14.2 I tilfælde af væsentlige ændringer af Forretningsbetingelserne vil Medlemmerne blive informeret herom via e-mail eller på anden tydelig måde. Ændringen vil ligeledes fremgå af Handyhands hjemmeside. For erhvervsdrivende Handyhandees gives som udgangspunkt mindst 15 dages varsel, medmindre ændringen er påkrævet som følge af lovgivning, sikkerhedshensyn, tekniske forhold eller anden tvingende grund."
      },
      "15": {
        "TITLE": "15. BETALINGSPROCESSOR",
        "TOC": "15. BETALINGSPROCESSOR",
        "P1": "15.1 Handyhand anvender en tredjepartsbetalingsprocessor, aktuelt Stripe, til at modtage betalinger, foretage udbetalinger og understøtte betalingsflowet mellem Medlemmer i overensstemmelse med disse Forretningsbetingelser. Medlemmet accepterer betalingsprocessorens relevante vilkår, som findes her: https://stripe.com/en-US/connect-account/legal. Betalingsflowet sker med forbehold for betalingsprocessorens regler, KYC-krav, sanktionstjek, risikovurderinger og gældende betalingsregulering."
      },
      "16": {
        "TITLE": "16. COOKIES",
        "TOC": "16. COOKIES",
        "P1": "16.1 Handyhand anvender cookies og andre identifikationsteknologier på Handyhand Platformen til en række formål, bl.a. til at verificere Medlemmer, til at forstå generel online adfærd og huske brugerpræferencer og -indstillinger, analysere trafikken og tendenser på webstedet samt Medlemmernes interesser.",
        "P2": "16.2 Medlemmet kan vælge at acceptere cookies eller ej.",
        "P3": "16.3 De fleste webbrowsere er som standard indstillet til at acceptere cookies. Hvis Medlemmet ønsker det, kan Medlemmet oftest vælge at indstille browseren til at fjerne eller afvise browser cookies. For at gøre dette følges instruktionerne i browseren, der som oftest findes i menuen „Hjælp“ eller „Indstillinger“."
      },
      "17": {
        "TITLE": "17. ØVRIGE BESTEMMELSER",
        "TOC": "17. ØVRIGE BESTEMMELSER",
        "P1": "17.1 Såfremt én eller flere af bestemmelserne i Forretningsbetingelserne bliver uvirksomme eller viser sig uigennemførlige, er parterne forpligtet til at træffe lovlige foranstaltninger, som i videst muligt omfang fører til samme eller tilsvarende resultat.",
        "P2": "17.2 Såfremt én eller flere bestemmelser i Forretningsbetingelserne ikke er virksomme eller viser sig uigennemførlige, har uigennemførligheden eller uvirksomheden ikke indflydelse på gyldigheden af de øvrige bestemmelser.",
        "P3": "17.3 Enhver tvist mellem Handyhand og et Medlem afgøres efter $$jurisdiction$$ ret."
      },
      "18": {
        "TITLE": "18. ØKONOMISK GODTGØRELSE",
        "TOC": "18. ØKONOMISK GODTGØRELSE",
        "P1": "18.1 Som ekstraordinær service tilbyder Handyhand at yde økonomisk godtgørelse på op til $$compensationMax$$ til Opgaveejer, såfremt:",
        "P1_LIST": {
          "1": "(a) Der efter Handyhands diskretionære skøn dokumenteret er mangler ved det af Handyhandee udførte arbejde,",
          "2": "(b) Opgaveejer, efter Handyhands diskretionære skøn, har lidt et dokumenteret tab, og",
          "3": "(c) Det dokumenterede tab overstiger $$compensationMin$$."
        },
        "P2": "18.2 Den økonomiske godtgørelse i henhold til punkt 18.1 er ekstraordinær og ændrer således ikke på udgangspunktet om, at Handyhand i intet tilfælde kan gøres særskilt ansvarlig for udførelsen af Opgaven, og omkostningsgodtgørelsen kan således i intet tilfælde overstige maksimum på $$compensationMax$$.",
        "P3": "18.3 Økonomisk godtgørelse i henhold til punkt 18.1 kan kun kræves af Opgaveejer, såfremt Opgaven fuldt ud er betalt gennem Handyhand Platformen. Såfremt Opgaven betales helt eller delvist ad andre veje end med Handyhands betalingsløsninger, er Handyhand ikke forpligtet til at yde økonomisk godtgørelse af nogen art til Opgaveejer.",
        "P4": "18.4 I tilfælde af at Handyhand udbetaler økonomisk godtgørelse til Opgaveejer, jf. punkt 18.1, tager Handyhand forbehold for at gøre krav gældende mod den pågældende Handyhandee svarende til den økonomiske godtgørelse betalt til Opgaveejer, jf. ligeledes punkt 18.2.",
        "P5": "18.5 Eventuelt krav om økonomisk godtgørelse i henhold til punkt 18.1 skal anmeldes skriftligt overfor Handyhand senest 30 dage efter arbejdets udførelse, idet muligheden for at modtage økonomisk godtgørelse ellers bortfalder.",
        "P6": "18.6 Uoverensstemmelser mellem Handyhand og Opgaveejer vedrørende en eventuel goodwill-kompensation skal søges afgjort i mindelighed. Såfremt der ikke kan findes en mindelig løsning, afgøres forholdet efter punkt 17.3, medmindre ufravigelige forbrugerretlige værnetingsregler tilsiger andet.",
        "READ_MORE": "Læs mere om hvornår denne kompensation kan og ikke kan benyttes her"
      }
    }
  }
}
